"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = exports.QUESTION_TYPES = exports.ANSWER_STATUS = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _server = _interopRequireDefault(require("react-dom/server"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = _interopRequireDefault(require("../Button/index.js"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _index2 = _interopRequireDefault(require("../TimerBar/index"));

var _DataStore = _interopRequireDefault(require("../../../KESI2/Stores/DataStore2"));

var _DataStorePaths = require("../../../KESI2/Stores/DataStorePaths");

var _FeatureManager = _interopRequireDefault(require("../../../utils/features/FeatureManager"));

var _RegisterInstance = _interopRequireDefault(require("../../../KESI2/Services/RegisterInstance"));

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _StringHelper = _interopRequireDefault(require("../../../helpers/StringHelper"));

var _Question = _interopRequireDefault(require("./Question2.scss"));

var _QuizStrings = require("./QuizStrings");

var _QuizRoundStyle = require("./styles/QuizRoundStyle");

var _UserLogsService = _interopRequireDefault(require("./services/UserLogsService"));

var _AppChannel = require("../../../KESI2/Services/AppChannel");

var _QuestionBox = _interopRequireDefault(require("./QuestionBox"));

var _AnswersBox = _interopRequireWildcard(require("./AnswersBox2.tsx"));

var _AlertHelper = require("../../../helpers/AlertHelper");

var _ErrorHelper = require("../../../helpers/ErrorHelper");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _DataStoreComponent2 = _interopRequireDefault(require("../../../common/components/DataStoreComponent/DataStoreComponent2"));

var _AppUtils = require("../../../utils/AppUtils");

var _AblyMessagingCommands = require("../../constants/AblyMessagingCommands");

var _QDGroupService = require("../../../KESI2/Services/QDGroupService");

var _ScreenHelper = _interopRequireDefault(require("../../../helpers/ScreenHelper"));

var _StringCompareHelper = require("../Quiz/Services/StringCompareHelper");

var _Question2HelperFuncs = require("./Question2HelperFuncs.tsx");

var _GameService = _interopRequireDefault(require("./services/GameService"));

var _Counter = _interopRequireDefault(require("./helperHooks/Counter.tsx"));

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _MathJaxHelper = _interopRequireDefault(require("../../../helpers/MathJaxHelper.tsx"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _Done = _interopRequireDefault(require("@material-ui/icons/Done"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Feedback = _interopRequireDefault(require("@material-ui/icons/Feedback"));

var _ThumbUp = _interopRequireDefault(require("@material-ui/icons/ThumbUp"));

var _ThumbDown = _interopRequireDefault(require("@material-ui/icons/ThumbDown"));

var _ChevronRight = _interopRequireDefault(require("@material-ui/icons/ChevronRight"));

var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));

var _ChatBubbleOutline = _interopRequireDefault(require("@material-ui/icons/ChatBubbleOutline"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var util = require('util');

var ANSWER_STATUS = {
  WRONG: 0,
  CORRECT: 1,
  TIME_OVER: 2,
  UNANSWERED: 3,
  EVALUATION: 4
};
exports.ANSWER_STATUS = ANSWER_STATUS;
var QUESTION_TYPES = {
  VALSTR: 'VALSTR',
  VALNUM: 'VALNUM',
  MC: 'MC',
  SC: 'SC',
  SE: 'SE',
  QD: 'QD',
  YN: 'YN'
};
exports.QUESTION_TYPES = QUESTION_TYPES;
var canAnswer = true;

var Question = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(Question, _DataStoreComponent);

  var _super = _createSuper(Question);

  function Question(props) {
    var _thisSuper, _thisSuper2, _this;

    (0, _classCallCheck2["default"])(this, Question);
    _this = _super.call(this, props);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "checkIfScrollingNeeded", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var answerEl, scrollIndicatorDisappearPadding, questionEl, questionElText;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              answerEl = _this.refAnswerScroll.current;
              scrollIndicatorDisappearPadding = 20;

              if (answerEl) {
                if (!_this._scrollIndicatorHidden && answerEl.scrollHeight <= answerEl.clientHeight + answerEl.scrollTop + scrollIndicatorDisappearPadding) {
                  _this._scrollIndicatorHidden = true;

                  _this.setState({
                    scrollIndicatorHidden: true
                  });
                } else if (_this._scrollIndicatorHidden && !(answerEl.scrollHeight <= answerEl.clientHeight + answerEl.scrollTop + scrollIndicatorDisappearPadding)) {
                  _this._scrollIndicatorHidden = false;

                  _this.setState({
                    scrollIndicatorHidden: false
                  });
                }
              }

              questionEl = _this.refQuestionScroll ? _this.refQuestionScroll.current : null;
              questionElText = _this.refQuestionScrollText ? _this.refQuestionScrollText.current : null;

              if (questionEl && questionElText) {
                if (!(questionElText.scrollHeight <= questionEl.offsetHeight + scrollIndicatorDisappearPadding)) {
                  _this.setState({
                    questionScrollIndicatorHidden: false
                  });
                }
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "innerForceUpdate", function () {
      _this.forceUpdate();
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "resetFontSizes", function () {
      _this.setState({
        bestAnswerFontSize: null,
        bestQuestionFontSize: null
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setQuestionStartTime", function () {
      if (_this.state.pauseStart) {
        _this.setState({
          startTime: new Date(_this.state.startTime + ((0, _now["default"])() - _this.state.pauseStart)).getTime(),
          pauseStart: null,
          timerBarStopped: false
        });
      } else {
        _this.setState({
          startTime: (0, _now["default"])(),
          timerBarStopped: false
        });
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "showImageOverlay", function (img) {
      if (_config["default"].resizeQuestionImgForSmallDevices) {
        if (_this.state.imgOverlay) {
          console.log('hideImg');

          _this.setState({
            imgOverlay: false,
            imgLink: ''
          });
        } else {
          console.log('showImg');

          _this.setState({
            imgOverlay: true,
            imgLink: img.src
          });
        }
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "closeFeedback", function () {
      _this.feedbackIsClosing = true;

      _this.setState({
        feedbackHidden: true,
        questionScrollingDisabled: false
      }, function () {
        _this.feedbackIsClosing = false;
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onNextQuestion", function (evenOnMCQuestions) {
      //changes for qdNugget in Base.
      setTimeout(function () {
        if (_this.refAnswerScroll && _this.refAnswerScroll.current) {
          _this.refAnswerScroll.current.scrollTop = 0;
        }

        _this.checkIfScrollingNeeded();
      }, 200);

      if (!canAnswer || !_this.canAnswer || _this.isGoingToNextQuestion || _this.feedbackIsClosing) {
        return;
      }

      if (!evenOnMCQuestions && _this.props.question.type === QUESTION_TYPES.MC && !_this.props.isSinglePlayer) {
        return;
      }

      var result = 'TIMEOUT';
      var selectedAnswer = -1;
      var answersArray = [];

      _this.selectedAnswers.forEach(function (answer) {
        answersArray.push(answer.number);
      });

      if (_this.state.answerStatus === ANSWER_STATUS.CORRECT) {
        result = 'CORRECT';
        selectedAnswer = _this.selectedAnswers.length === 1 ? _this.selectedAnswers[0].number : answersArray; //this.state.selectedAnswers
      } else if (_this.state.answerStatus === ANSWER_STATUS.WRONG) {
        result = 'WRONG';
        selectedAnswer = _this.selectedAnswers.length === 1 ? _this.selectedAnswers[0].number : answersArray; //this.state.selectedAnswers
      }

      answersArray = [];

      if (_this.props.question.type === QUESTION_TYPES.SE) {
        selectedAnswer = _this.state.selfEvaluationAnswer;

        _this.setState({
          selfEvaluationAnswer: null
        });
      }

      if (_this.props.editorMode || _this.props.isSinglePlayer) {
        if (_this.props.reviewMode) {
          return;
        }

        _this.setState({
          answerStatus: ANSWER_STATUS.UNANSWERED,
          showOverlay: 'none',
          feedbackHidden: false,
          questionScrollingDisabled: false,
          questionLearned: false,
          specificFeedbackHidden: true
        });

        var answers = document.querySelectorAll("*[id^=\"answers_".concat(_this.props.question.number, "\"]"));
        answers.forEach(function (answer) {
          answer.style.border = 'none';
        });

        if (_this.props.isSinglePlayer) {
          _this.props.onSubmitAnswer(selectedAnswer, _this.state.answerStatus);

          _this.selectedAnswers = [];

          _this.setState({
            selectedAnswers: [],
            textfieldFocusedBefore: false
          });
        }

        return;
      }

      _this.isGoingToNextQuestion = true;
      var durations = {
        read: 0,
        answer: _this.state.endTime - _this.state.startTime,
        feedback: (0, _now["default"])() - _this.state.endTime
      }; // LOG: learning event

      if (!_this.props.isSinglePlayer) {
        _UserLogsService["default"].postQuestionResponseLog(_this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_USER].id, _this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_GAME].id, _this.props.question, durations, result);
      }

      setTimeout(function () {
        _this.props.onSubmitAnswer(selectedAnswer);
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "showAndSaveAnswers", function (user, opponent, question, selectedAnswers) {
      var game = _this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_GAME];
      var dynamicStyles = (0, _QuizRoundStyle.getQuestionStyles)(_this.state, _this.props.parentDomId);
      var correctAnswers = [];
      var answers = question.answers; // get opponent's answer

      var opponentAnswers = _this.props.editorMode || _this.props.isSinglePlayer ? 5 : _this.getOpponentsAnswer(opponent, game.rounds[question.round], question);
      var answersHTML = document.querySelectorAll("div#answers_question_".concat(question.number, " .answerBox"));
      var hideFeedbackByGroup = _this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_GROUP_HIDE_FEEDBACK];
      var selectedAnswerNumbers = [];
      selectedAnswers.forEach(function (answer) {
        selectedAnswerNumbers.push(answer.number);
      });

      for (var i = 0; i < answersHTML.length; i++) {
        var answer = answers[i];
        console.log('answer', answer, i, answer.isCorrect, selectedAnswers);

        if (!hideFeedbackByGroup && answer.isCorrect) {
          correctAnswers.push(answer); // mark questions as correct (by config)

          if (_config["default"].useErgoFeedbackStyle) {
            // setting the text color of the correct answer to green
            var answerBoxEl = document.getElementById("answers_span_".concat(question.number, "_").concat(answer.number));
            answerBoxEl.style.setProperty('color', dynamicStyles.textCorrectStyle.color, 'important');

            if (selectedAnswerNumbers.indexOf(answer.number) > -1) {
              answersHTML[i].style.border = dynamicStyles.correctStyle.border;
              var muiButton = answersHTML[i].getElementsByClassName('MuiButtonBase-root')[0];

              if (muiButton) {
                muiButton.style.setProperty('color', dynamicStyles.correctStyle.color, 'important');
              }
            } else {
              var _muiButton = answersHTML[i].getElementsByClassName('MuiButtonBase-root')[0];

              if (_muiButton) {
                _muiButton.style.setProperty('color', dynamicStyles.wrongStyle.color, 'important');
              }
            }
          } else {
            if (selectedAnswerNumbers.indexOf(answer.number) > -1) {
              if (_config["default"].useNewMCSCStyling && (question.type === QUESTION_TYPES.SC || question.type === QUESTION_TYPES.MC)) {
                console.log('appendIcon correct');

                var checkIcon = _server["default"].renderToString( /*#__PURE__*/_react["default"].createElement(_Done["default"], {
                  className: _Question["default"].icon
                }));

                var node = document.createElement('div');

                if (answer.number === opponentAnswers || opponentAnswers && opponentAnswers.length > 0 && opponentAnswers.indexOf(answer.number) > -1) {
                  node.className = "".concat(_Question["default"].correctIconWithOpp);
                } else {
                  node.className = "".concat(_Question["default"].correctIcon);
                }

                node.id = "icon_".concat(i);
                node.style.backgroundColor = dynamicStyles.correctStyle.color;
                node.innerHTML = checkIcon;
                answersHTML[i].parentNode.appendChild(node);
              } else {
                answersHTML[i].style.border = dynamicStyles.correctStyle.border;
              }
            }
            /*
              else {
                if (target.useNewMCSCStyling && (question.type === QUESTION_TYPES.SC || question.type === QUESTION_TYPES.MC)) {
                  console.log('appendIcon wrong')
                  const wrongIcon = ReactDOMServer.renderToString(<WrongIcon className={ownStyles.icon} />)
                  const node = document.createElement('div')
                  if ((answer.number === opponentAnswers || (opponentAnswers && opponentAnswers.length > 0 && opponentAnswers.indexOf(answer.number) > -1))) {
                    node.className = `${ownStyles.correctIconWithOpp}`
                  }
                  else {
                    node.className = `${ownStyles.correctIcon}`
                  }
                   node.id = `icon_${i}`
                  node.style.backgroundColor = dynamicStyles.wrongStyle.color
                  node.innerHTML = wrongIcon
                  answersHTML[i].parentNode.appendChild(node)
                }
                else if (!target.useNewMCSCStyling && (question.type === QUESTION_TYPES.SC || question.type === QUESTION_TYPES.MC)) {
                  answersHTML[i].style.border = dynamicStyles.correctStyle.border
                }
              }
              */

          }
        } else if (!hideFeedbackByGroup && !answer.isCorrect) {
          if (_config["default"].useErgoFeedbackStyle) {
            // setting the text color of the correct answer to red
            var _answerBoxEl = document.getElementById("answers_span_".concat(question.number, "_").concat(answer.number));

            _answerBoxEl.style.setProperty('color', dynamicStyles.wrongStyle.color, 'important');

            if (selectedAnswerNumbers.indexOf(answer.number) > -1) {
              answersHTML[i].style.border = dynamicStyles.wrongStyle.border;
              var _muiButton2 = answersHTML[i].getElementsByClassName('MuiButtonBase-root')[0];

              if (_muiButton2) {
                _muiButton2.style.setProperty('color', dynamicStyles.wrongStyle.color, 'important');
              }
            }
          } else {
            if (selectedAnswerNumbers.indexOf(answer.number) > -1) {
              if (_config["default"].useNewMCSCStyling && (question.type === QUESTION_TYPES.SC || question.type === QUESTION_TYPES.MC)) {
                var _checkIcon = _server["default"].renderToString( /*#__PURE__*/_react["default"].createElement(_Close["default"], {
                  className: _Question["default"].icon
                }));

                var _node = document.createElement('div');

                if (answer.number === opponentAnswers || opponentAnswers && opponentAnswers.length > 0 && opponentAnswers.indexOf(answer.number) > -1) {
                  _node.className = "".concat(_Question["default"].correctIconWithOpp);
                } else {
                  _node.className = "".concat(_Question["default"].correctIcon);
                }

                _node.id = "icon_".concat(i);
                _node.style.backgroundColor = dynamicStyles.wrongStyle.color;
                _node.innerHTML = _checkIcon;
                answersHTML[i].parentNode.appendChild(_node);
              } else {
                answersHTML[i].style.border = dynamicStyles.wrongStyle.border;
              }
            }
            /*
            else {
              if (target.useNewMCSCStyling && (question.type === QUESTION_TYPES.SC || question.type === QUESTION_TYPES.MC)) {
                const checkIcon = ReactDOMServer.renderToString(<CheckIcon className={ownStyles.icon} />)
                const node = document.createElement('div')
                if ((answer.number === opponentAnswers || (opponentAnswers && opponentAnswers.length > 0 && opponentAnswers.indexOf(answer.number) > -1))) {
                  node.className = `${ownStyles.correctIconWithOpp}`
                }
                else {
                  node.className = `${ownStyles.correctIcon}`
                }
                 node.id = `icon_${i}`
                node.style.backgroundColor = dynamicStyles.correctStyle.color
                node.innerHTML = checkIcon
                answersHTML[i].parentNode.appendChild(node)
              }
              else if (!target.useNewMCSCStyling && (question.type === QUESTION_TYPES.SC || question.type === QUESTION_TYPES.MC)) {
                answersHTML[i].style.border = dynamicStyles.wrongStyle.border
              }
            }
            */

          }
        } // flag opponent's answer


        if ((answer.number === opponentAnswers || opponentAnswers && opponentAnswers.length > 0 && opponentAnswers.indexOf(answer.number) > -1) && !_this.props.isSinglePlayer) {
          var opponentTag = document.createElement('p');
          var isMCSC = question.type === QUESTION_TYPES.MC || question.type === QUESTION_TYPES.SC;
          opponentTag.className = isMCSC ? _config["default"].useNewMCSCStyling ? _Question["default"].opponentAnswerMCSC : _Question["default"].opponentAnswerMCSCold : _Question["default"].opponentAnswer;

          if (opponentAnswers !== selectedAnswers && !answer.isCorrect && !isMCSC) {
            opponentTag.style.borderRadius = '5px 5px 0 0';
          }

          opponentTag.style.zIndex = 5;
          opponentTag.style.backgroundColor = _config["default"].useErgoFeedbackStyle ? answer.isCorrect ? dynamicStyles.correctStyle.color : dynamicStyles.wrongStyle.color : dynamicStyles.opponentAnswerStyle.backgroundColor; // opponentTag.style.width = '48%'

          opponentTag.style.color = '#ffffff';
          opponentTag.style.textAlign = 'center';
          var opponentNameNode = document.createTextNode(_this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_SELECTED_OPPONENT].nickname);
          opponentTag.appendChild(opponentNameNode); // eElement.insertBefore(newFirstElement, eElement.firstChild);

          answersHTML[i].insertBefore(opponentTag, answersHTML[i].firstChild); // answersHTML[i].appendChild(opponentTag)
        }
      }

      var sortedCorrectAnswers = _this.sortByAnswerNumber(correctAnswers); //  correctNumbers.sort()


      var sortedSelectedAnswers = _this.sortByAnswerNumber(selectedAnswers);

      var correct = (0, _stringify["default"])(sortedCorrectAnswers) === (0, _stringify["default"])(sortedSelectedAnswers);
      console.log('question2', correct, sortedCorrectAnswers, sortedSelectedAnswers, (0, _stringify["default"])(correctAnswers) === (0, _stringify["default"])(selectedAnswers));
      var saveAnswers = [];
      selectedAnswers.forEach(function (answer) {
        if (_this.props.question.type === QUESTION_TYPES.VALSTR || _this.props.question.type === QUESTION_TYPES.VALNUM) {
          var answerParts = JSON.parse(_this.props.question.answers[0].answer);
          var index = answerParts.indexOf(answer.closestAnswer);

          if (_this.props.question.type === QUESTION_TYPES.VALNUM && index === -1) {
            saveAnswers.push(0);
          } else {
            saveAnswers.push(index);
          }
        } else if (_this.props.question.type === QUESTION_TYPES.SE) {
          saveAnswers.push(0);
        } else {
          saveAnswers.push(answer.number);
        }
      });

      if (_this.props.question.type === QUESTION_TYPES.VALSTR || _this.props.question.type === QUESTION_TYPES.VALNUM || _this.props.question.type === QUESTION_TYPES.SE) {
        correct = selectedAnswers && selectedAnswers.length > 0 ? selectedAnswers[0].isCorrect : false;
      }

      if (!_this.props.editorMode) {
        var answerObj = {
          number: _this.props.question.number,
          value: saveAnswers,
          score: correct ? question.score : _this.props.reducePointsOnError ? -question.score : 0,
          factor: _this.props.question.type === QUESTION_TYPES.VALSTR || _this.props.question.type === QUESTION_TYPES.VALNUM ? selectedAnswers && selectedAnswers.length > 0 && selectedAnswers[0].factor ? selectedAnswers[0].factor : 0 : 0
        };

        if (!_this.props.isSinglePlayer) {
          game.rounds[question.round].state[user.playerState || 'challenger'].push(answerObj);
          var currentRoundStates = _this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_CURRENT_ROUND_STATES] || {};
          var currentGame = _this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_GAME];
          var currentGameState = currentRoundStates[currentGame.id] || [];

          if (currentGameState.length < _this.props.numberOfQuestions) {
            console.log('setting currentRoundStates1', JSON.parse((0, _stringify["default"])(currentRoundStates)));
            var index = currentGameState.findIndex(function (item) {
              return item.number === answerObj.number;
            });

            if (index === -1) {
              currentGameState.push(answerObj);
            } else {
              currentGameState[index] = answerObj;
            }

            console.log('setting currentRoundStates2', currentGameState);
            currentRoundStates[currentGame.id] = currentGameState;
            console.log('setting currentRoundStates3', JSON.parse((0, _stringify["default"])(currentRoundStates)));

            _DataStore["default"].setSingleData(_DataStorePaths.DATA_STORE_PATHS.QD_CURRENT_ROUND_STATES, JSON.parse((0, _stringify["default"])(currentRoundStates)));
          } // else {
          //   currentRoundStates[currentGame.id] = []
          //   console.log('we have the fith question, setting currentRoundStates1', JSON.parse(JSON.stringify(currentRoundStates)))
          //   DataStore.setSingleData(DATA_STORE_PATHS.QD_CURRENT_ROUND_STATES, JSON.parse(JSON.stringify(currentRoundStates)))
          // }

        } else {
          if (_this.props.saveAnswer && !_this.props.reviewMode) {
            _this.props.saveAnswer(answerObj, selectedAnswers, correct);
          }
        }
      } // calculations for score is done on QuizOverview only as any calculations here can be overwritten by the server anyway

      /**
       *  This action is superfluous as it updates the game in the state which is already updated.
       *  (There even seems to be a problem when answering questions too quickly as it is allowed by the DOM after moment
       *  but the state (triggered by this action) may not have done all app wide state changes and thus the updates may
       *  not appear in order
       *
       *  This only happens when the app is build in non-debug mode since it only happens if no console.logs delay the
       *  execution.)
       */
      // EquizzerActions.updateGame(game)


      _DataStore["default"].setSingleData(_DataStorePaths.DATA_STORE_PATHS.QD_GAME, game);

      return correctAnswers;
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "sortByAnswerNumber", function (array) {
      return array.sort(function (a, b) {
        if (a && b && (a.number || a.number === 0) && (b.number || b.number === 0)) {
          if (a.number > b.number) return 1;else if (a.number < b.number) return -1;else return 0;
        } else {
          if (a > b) return 1;else if (a < b) return -1;else return 0;
        }
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "isAnswerCorrect", function (answerNumber) {
      var answers = _this.props.question.answers;
      return answers[answerNumber].isCorrect;
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "hideFeedback", function (e) {
      e.stopPropagation();

      _this.setState({
        feedbackHidden: true,
        questionScrollingDisabled: false
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setMCAlert", function () {
      _this.setState({
        showMCAlert: true
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "unsetMCAlert", function () {
      _this.setState({
        showMCAlert: false,
        sendMC: false
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "renderMCAlert", function () {
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
        className: _Question["default"].mcText
      }, "Bei einer Multiple Choice Frage k\xF6nnten auch mehrere Antworten richtig sein. M\xF6chten sie Ihre Antwort so abschicken?"), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Question["default"].MCAlertButtonDiv
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _Question["default"].hideFeedbackButton,
        onClick: function onClick() {
          _this.setState({
            sendMC: true,
            questionScrollingDisabled: true,
            feedbackHidden: false
          });
        }
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], null, 'JA')), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Question["default"].hideFeedbackButton,
        onClick: function onClick() {
          _this.setState({
            showMCAlert: false
          });
        }
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], null, 'NEIN')))));
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getFeedback", function () {
      if (_this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_GROUP_HIDE_FEEDBACK]) {
        return null;
      }

      if (!_this.hasFeedback()) {
        return null;
      }

      var questionSpecificFeedback = _this.getFreetextAnswerSpecificFeedback() || _this.getAnswerSpecificFeedback() || _this.getDefaultFeedback();

      var historyBasedFeedbackDiv = null;

      if (_config["default"].useHistoryBasedFeedback) {
        var history = _this.props.question.learningDistance.history + (_this.state.answerStatus === ANSWER_STATUS.CORRECT ? 'R' : 'F');
        var historyBasedFeedbackKey = (0, _keys["default"])(_this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_HISTORY_BASED_FEEDBACK]).find(function (regex) {
          return history.match(new RegExp(regex)) !== null;
        });
        var feedbackArray = historyBasedFeedbackKey ? _this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_HISTORY_BASED_FEEDBACK][historyBasedFeedbackKey] : null;
        var historyBasedFeedback = historyBasedFeedbackKey ? feedbackArray[Math.floor(Math.random() * feedbackArray.length)] : null;
        historyBasedFeedbackDiv = historyBasedFeedback ? /*#__PURE__*/_react["default"].createElement("div", {
          dangerouslySetInnerHTML: {
            __html: _StringHelper["default"].removeLeadingAndTrailingBrAndPInHtml(historyBasedFeedback)
          }
        }) : null;
      }

      var mathMl = null;
      var feedbackToUse = questionSpecificFeedback;
      var feedbackParts = null;

      if (questionSpecificFeedback && _DeviceInfoHelper["default"].isAndroid() && _MathJaxHelper["default"]) {
        mathMl = _StringHelper["default"].getMathMlContent(questionSpecificFeedback);

        if (mathMl && mathMl.length > 0) {
          feedbackToUse = questionSpecificFeedback.replace(mathMl[0], '|||');
          feedbackParts = feedbackToUse.split('|||');
        }
      }

      var showSpecificFeedbackInfo = _this.isMCQuestion() && _this.props.question && _this.props.question.detailedFeedback; //&& this.hasAnswerSpecificFeedback() //show detailed feedback info even if no answer was given


      var group = _DataStore["default"].getElementByPathImmediately(_DataStorePaths.DATA_STORE_PATHS.QD_GROUP);

      var hasLearnedFeedback = !!(group && group.value && group.value.learnedFeedback);
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: 'feedbackDiv'
      }, _this.state.questionLearned && hasLearnedFeedback ? _this.renderLearnedFeedback() : null, historyBasedFeedbackDiv, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !feedbackParts && /*#__PURE__*/_react["default"].createElement("div", {
        dangerouslySetInnerHTML: {
          __html: _StringHelper["default"].removeLeadingAndTrailingBrAndPInHtml(feedbackToUse || '')
        }
      }), feedbackParts && feedbackParts.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        dangerouslySetInnerHTML: {
          __html: _StringHelper["default"].removeLeadingAndTrailingBrAndPInHtml(feedbackParts[0] || '')
        }
      }), /*#__PURE__*/_react["default"].createElement(_MathJaxHelper["default"], {
        math: mathMl[0]
      }), feedbackParts.length > 1 && /*#__PURE__*/_react["default"].createElement("div", {
        dangerouslySetInnerHTML: {
          __html: _StringHelper["default"].removeLeadingAndTrailingBrAndPInHtml(feedbackParts[1] || '')
        }
      }))), showSpecificFeedbackInfo ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
        className: _Question["default"].mcText
      }, "Bitte schauen Sie sich das Feedback zu den einzelnen Antworten an."), /*#__PURE__*/_react["default"].createElement("p", {
        className: _Question["default"].mcInfoText
      }, "(Das Feedback wird angezeigt, wenn Sie auf das Icon ", /*#__PURE__*/_react["default"].createElement(_Feedback["default"], null), " neben der Antwort klicken.)")) : null);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "showSpecificFeedback", function (feedback) {
      if (_this.state.specificFeedbackHidden) {
        _this.setState({
          specificFeedbackHidden: false
        });

        _this.specificFeedback = feedback;
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "renderSpecificFeedback", function (feedback) {
      var mathMl = null;
      var feedbackToUse = feedback;
      var feedbackParts = null;

      if (feedback && _DeviceInfoHelper["default"].isAndroid() && _MathJaxHelper["default"]) {
        mathMl = _StringHelper["default"].getMathMlContent(feedback);

        if (mathMl && mathMl.length > 0) {
          feedbackToUse = feedback.replace(mathMl[0], '|||');
          feedbackParts = feedbackToUse.split('|||');
        }
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        id: 'feedbackDiv'
      }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !feedbackParts && /*#__PURE__*/_react["default"].createElement("div", {
        dangerouslySetInnerHTML: {
          __html: _StringHelper["default"].removeLeadingAndTrailingBrAndPInHtml(feedbackToUse || '')
        }
      }), feedbackParts && feedbackParts.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        dangerouslySetInnerHTML: {
          __html: _StringHelper["default"].removeLeadingAndTrailingBrAndPInHtml(feedbackParts[0] || '')
        }
      }), /*#__PURE__*/_react["default"].createElement(_MathJaxHelper["default"], {
        math: mathMl[0]
      }), feedbackParts.length > 1 && /*#__PURE__*/_react["default"].createElement("div", {
        dangerouslySetInnerHTML: {
          __html: _StringHelper["default"].removeLeadingAndTrailingBrAndPInHtml(feedbackParts[1] || '')
        }
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Question["default"].overlayCloseSpecific,
        onClick: function onClick(e) {
          e.stopPropagation();

          _this.setState({
            specificFeedbackHidden: true,
            questionScrollingDisabled: false
          });
        }
      }, /*#__PURE__*/_react["default"].createElement(_Clear["default"], {
        style: {
          fontSize: 'x-large'
        }
      })));
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onSelfEvaluation", function (answer) {
      var feedbackHiddenByGroup = _DataStore["default"].getElementByPathImmediately(_DataStorePaths.DATA_STORE_PATHS.QD_GROUP_HIDE_FEEDBACK);

      if (!feedbackHiddenByGroup) {
        _this.setState({
          showOverlay: '',
          selfEvaluationAnswer: answer,
          timerBarStopped: true,
          feedbackHidden: false,
          answerStatus: ANSWER_STATUS.EVALUATION,
          questionLearned: false
        });
      } else {
        canAnswer = true;
        _this.canAnswer = true;

        _this.onSelectAnswer(null, 0);
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onSelectAnswer", function (selected, points) {
      if (!canAnswer || !_this.canAnswer) {
        console.log('answer denied', canAnswer, _this.canAnswer);
        return;
      }
      /**
      * DO NOT change the copying of the object // array here please. It resulted in a bug where
       * a freetext answer would get the 'isCorrect' value of the previous one.
       */


      if (!(0, _isArray["default"])(selected)) {
        _this.selectedAnswers.push(_objectSpread({}, selected));
      } else {
        _this.selectedAnswers = (0, _toConsumableArray2["default"])(selected);
      }

      var selectedAnswers = _this.selectedAnswers;
      var answersNumbers = [];
      selectedAnswers.forEach(function (answer) {
        answersNumbers.push(answer.number);
      });
      canAnswer = false;
      _this.canAnswer = true; // let correctAnswer

      var isCorrect;
      var almostCorrect = false; // let matched

      if (_this.props.question.type === QUESTION_TYPES.VALSTR || _this.props.question.type === QUESTION_TYPES.VALNUM) {
        // if (Array.isArray(selected))
        // TODO the prop learned should be set in the for loops
        var answerParts = JSON.parse(_this.props.question.answers[0].answer);
        var userInput = _this.selectedAnswers[0].answer; // normalize user input

        userInput = (0, _Question2HelperFuncs.normalizeInput)(userInput);

        if (_this.props.question.type === QUESTION_TYPES.VALNUM) {
          userInput = Number(userInput);
        }

        var closestAnswer = '';
        isCorrect = answerParts.some(function (answer) {
          closestAnswer = String(answer);
          selectedAnswers[0].factor = _this.props.question.type === QUESTION_TYPES.VALNUM ? 0 : 1;
          return String(answer).toLowerCase() === String(userInput).toLowerCase(); // no matter if it's a number or a string
        });

        if (!isCorrect) {
          if (_this.props.question.type === QUESTION_TYPES.VALNUM) {
            var approx = _this.props.question.approx || 0;
            almostCorrect = answerParts.some(function (value) {
              var numVal = Number(value);
              var factor = userInput > numVal ? userInput - numVal : numVal - userInput;
              selectedAnswers[0].factor = factor;
              closestAnswer = String(value);
              return userInput >= numVal - approx && userInput <= numVal + approx;
            });
          } else if (_this.props.question.type === QUESTION_TYPES.VALSTR) {
            var _approx = _this.props.question.approx || 1;

            almostCorrect = answerParts.some(function (correctAnswer) {
              console.log('VALSTR', _approx, _this.props.question, (0, _StringCompareHelper.sim)(userInput.toLowerCase(), correctAnswer.toLowerCase()));
              var factor = (0, _StringCompareHelper.sim)(userInput.toLowerCase(), correctAnswer.toLowerCase());
              selectedAnswers[0].factor = factor;
              closestAnswer = correctAnswer;
              return factor >= _approx;
            });
          }
        }

        if (isCorrect || almostCorrect) {
          selectedAnswers[0].isCorrect = true;
        }

        if (almostCorrect) {
          selectedAnswers[0].almostCorrect = true;
        }

        selectedAnswers[0].text = String(userInput);
        selectedAnswers[0].bestCorrectAnswer = answerParts[0];
        selectedAnswers[0].closestAnswer = closestAnswer;
      }

      if (_this.props.question.type === QUESTION_TYPES.SE) {
        selectedAnswers[0].score = points;
        isCorrect = points === _this.props.question.score;
        selectedAnswers[0].isCorrect = isCorrect;
      }

      var correctAnswers = _this.showAndSaveAnswers(_this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_USER], _this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_SELECTED_OPPONENT], _this.props.question, selectedAnswers);

      var questionType = _this.props.question.type;
      var hideFeedbackByGroup = _this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_GROUP_HIDE_FEEDBACK];

      if (questionType !== QUESTION_TYPES.VALNUM && questionType !== QUESTION_TYPES.VALSTR && questionType !== QUESTION_TYPES.SE) {
        var dynamicStyles = (0, _QuizRoundStyle.getQuestionStyles)(_this.state, _this.props.parentDomId);
        selectedAnswers.forEach(function (selectedElem, index) {
          var elem = document.querySelector("#answers_".concat(_this.props.question.number, "_").concat(selectedElem.number, " "));

          if (!hideFeedbackByGroup) {
            if (!_config["default"].useErgoFeedbackStyle) {
              var isYNQD = questionType === QUESTION_TYPES.QD || questionType === QUESTION_TYPES.YN;

              if (isYNQD) {
                var style = selectedElem.isCorrect ? dynamicStyles.correctStyle : dynamicStyles.wrongStyle;
                elem.style.border = style.border;
              }
            }
          }
        });
        var matched = correctAnswers.filter(function (answer) {
          return selectedAnswers.findIndex(function (answer2) {
            return (0, _stringify["default"])(answer2) === (0, _stringify["default"])(answer);
          }) >= 0;
        });
        isCorrect = selectedAnswers.length > 0 && matched.length === correctAnswers.length && selectedAnswers.length === correctAnswers.length;
      }

      if (_config["default"].defaultUseVibration && _DeviceInfoHelper["default"].isAndroid() && !isCorrect && window.navigator.vibrate) {
        // vibrate only on Android because we need a short vibration here and short vibrations are not supported on iOS
        window.navigator.vibrate(50);
      }

      var answerStatus = -1;
      var questionLearned = false;
      var feedbackHiddenByGroup = _this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_GROUP_HIDE_FEEDBACK];

      if (_this.props.question.type === QUESTION_TYPES.SE && !feedbackHiddenByGroup) {
        answerStatus = ANSWER_STATUS.EVALUATION;
      } else {
        if (isCorrect || almostCorrect) {
          questionLearned = _this.checkIfQuestionLearned();
          answerStatus = ANSWER_STATUS.CORRECT;
        } else {
          answerStatus = ANSWER_STATUS.WRONG;
        } // answerStatus = (isCorrect || almostCorrect ? ANSWER_STATUS.CORRECT : ANSWER_STATUS.WRONG)

      }

      var scoreToLog = _this.selfEvaluationScore;
      var answerToLog = _this.state.selfEvaluationAnswer;
      _this.selfEvaluationScore = 0;

      if (_config["default"].allowDifferentQuestionBoxSizes) {
        var questionBoxFrameId = "questionText_".concat(_this.props.question.number);
        var el = document.getElementById(questionBoxFrameId);

        if (el) {
          el.scrollTop = 0;
        }
      }

      _this.setState({
        showOverlay: '',
        answerStatus: answerStatus,
        questionScrollingDisabled: true,
        timerBarStopped: true,
        endTime: (0, _now["default"])(),
        selectedAnswers: answersNumbers,
        // selectedAnswer: selected.number,
        textZoomed: false,
        textToZoom: null,
        zoomDivPosition: null,
        isZoomedQuestion: false,
        zoomTransform: null,
        zoomScale: 1,
        zoomFinished: false,
        animationFinished: false,
        questionLearned: questionLearned
      }, function () {
        setTimeout(function () {
          canAnswer = true;
        }, 200);
      }); // this.overlayTimeout = setTimeout(() => {
      //   this.props.onSubmitAnswer()
      // },2000)


      if (_this.props.question.type === QUESTION_TYPES.SE) {
        if (!_this.props.isSinglePlayer) {
          var durations = {
            read: 0,
            answer: _this.state.endTime - _this.state.startTime,
            feedback: (0, _now["default"])() - _this.state.endTime
          };

          _UserLogsService["default"].postSelfEvaluationResponseLog(_this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_USER].id, _this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_GAME].id, _this.props.question, durations, answerToLog, scoreToLog);
        }

        canAnswer = true;
        _this.canAnswer = true;

        _this.onNextQuestion(true);
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "checkIfQuestionLearned", function () {
      var returnValue = false;
      var learningDistance = _this.props.question.learningDistance;

      if (_this.props.question.progressionGroup && _this.props.question.progressionLevel) {
        returnValue = _this.props.question.progressionLevel >= learningDistance.target;
      }

      if (learningDistance) {
        var _target = learningDistance.target;
        var learned = learningDistance.current === null ? 1 : learningDistance.current + 1;
        returnValue = learned >= _target;
      }

      var groupData = _DataStore["default"].getElementByPathImmediately(_DataStorePaths.DATA_STORE_PATHS.QD_GROUP);

      if (groupData && groupData.value && !groupData.value.learnedFeedback) {
        returnValue = false;
      }

      return returnValue;
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "handleTagReceivedMessage", function (message) {
      for (var i = 0; i < _this.feedbackReceivedTimeouts.length; i++) {
        if (_this.feedbackReceivedTimeouts[i].id === message.clientId) {
          clearTimeout(_this.feedbackReceivedTimeouts[i].timeout);

          _this.feedbackReceivedTimeouts.splice(i, 1);

          return;
        }
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "triggerKesiAction", function () {
      var partners = _this.state.data[_DataStorePaths.DATA_STORE_PATHS.CONNECT_PARTNER_IDS] || [];

      for (var i = 0; i < partners.length; i++) {
        (0, _AppChannel.sendMessage)(_AblyMessagingCommands.ABLY_COMMANDS.FEEDBACK_TAGS, {
          tags: [_this.props.question.detailedFeedback[_this.state.selectedAnswer].feedbackTag]
        }, partners[i]);

        _this.feedbackReceivedTimeouts.push({
          id: partners[i],
          timeout: setTimeout(_this.triggerKesiActionPushMessage, 10000)
        });
      } // still pushing to feedbacktags because we might want to do roundend events later


      _this.props.kesiFeedbackTags.push(_this.props.question.detailedFeedback[_this.state.selectedAnswer].feedbackTag);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "triggerKesiActionPushMessage", function () {
      // Todo: implement push message
      console.log('Sending push message...');
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "hasKesiAction", function () {
      if ((_this.state.answerStatus === ANSWER_STATUS.TIME_OVER || _this.state.answerStatus === ANSWER_STATUS.WRONG) && _this.state.selectedAnswer && _this.props.question.detailedFeedback && _this.props.question.detailedFeedback[_this.state.selectedAnswer] && _this.props.question.detailedFeedback[_this.state.selectedAnswer].feedbackTag) {
        return /*#__PURE__*/_react["default"].createElement(_index["default"], {
          className: _Question["default"].kesiActionBtn,
          onClick: function onClick(e) {
            _this.triggerKesiAction();
          }
        }, "Nochmal nachlesen");
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onTimeOver", function () {
      if (_this.state.answerStatus === ANSWER_STATUS.UNANSWERED) {
        if (_this.state.imgOverlay) {
          _this.showImageOverlay(null);
        }

        _this.showAndSaveAnswers(_this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_USER], _this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_SELECTED_OPPONENT], _this.props.question, _this.selectedAnswers);

        _this.setState({
          showOverlay: '',
          answerStatus: ANSWER_STATUS.TIME_OVER,
          endTime: (0, _now["default"])(),
          showExposition: false,
          textZoomed: false,
          textToZoom: null,
          zoomDivPosition: null,
          isZoomedQuestion: false,
          zoomTransform: null,
          zoomScale: 1,
          zoomFinished: false,
          animationFinished: false,
          timerBarStopped: true,
          showMCAlert: false
        });

        if (_config["default"].defaultUseVibration && window.navigator.vibrate) {
          window.navigator.vibrate(1000);
        }
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onUserFeedbackButtonClicked", function () {
      var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var errorCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (errorCode === 1) {
        _this.userEmail = '';
      } else if (errorCode === 2) {
        _this.userFeedbackMessage = '';
      }

      var okButton = {
        label: (0, _QuizStrings.getString)('SEND_FEEDBACK'),
        callback: _this.sendUserFeedback
      };
      var htmlError = errorMessage ? "<div>".concat(errorMessage, "</div>") : null;
      (0, _AlertHelper.showWideAlertHtmlWithTextfields)((0, _QuizStrings.getString)('FEEDBACK_EXPLANATION_MESSAGE'), (0, _QuizStrings.getString)('FEEDBACK_EXPLANATION_TITLE'), htmlError, [{
        id: _StringHelper["default"].createShortId(),
        label: (0, _QuizStrings.getString)('QUIZ_EMAIL'),
        onChange: _this.setUserEmail,
        type: 'email',
        value: _this.userEmail
      }, {
        id: _StringHelper["default"].createShortId(),
        label: (0, _QuizStrings.getString)('MESSAGE'),
        onChange: _this.setUserFeedbackMessage,
        type: 'textarea',
        style: {
          height: '10em'
        },
        value: _this.userFeedbackMessage
      }], true, null, [okButton]);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getFeedbackMessageBody", function () {
      var userMessage = _this.userFeedbackMessage;
      var question = util.inspect(_this.props.question);
      var isUserInput = _this.props.question.type === QUESTION_TYPES.VALNUM || _this.props.question.type === QUESTION_TYPES.VALSTR;
      var selectedAnswer = isUserInput ? _this.selectedAnswers[0].answer : _this.state.selectedAnswers;
      var userEmail = _this.userEmail;
      return "User-Feedback\n <div style=\"padding-left: 20px\">".concat(userMessage, "</div><div style=\"padding-left: 20px\">").concat(userEmail, "</div> \n\n Frage: <pre>").concat(question, "</pre> \n ").concat(isUserInput ? 'Usereingabe' : 'Gewählte Antwort', " (Nummer): <pre>").concat(selectedAnswer, "</pre>");
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "sendUserFeedback", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var user, feature, requestCode, deviceUuid, userid, password, auth, token;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this.userFeedbackMessage.trim()) {
                _context2.next = 5;
                break;
              }

              _this.onUserFeedbackButtonClicked('Bitte gib eine Nachricht ein.', 2);

              return _context2.abrupt("return");

            case 5:
              if (!(!_this.userEmail.trim() || !_StringHelper["default"].isEmailAdress(_this.userEmail))) {
                _context2.next = 8;
                break;
              }

              _this.onUserFeedbackButtonClicked('Bitte gib eine gültige Email ein.', 1);

              return _context2.abrupt("return");

            case 8:
              user = _config["default"].defaultUser;
              feature = _FeatureManager["default"].getFeature('equeoqd');
              requestCode = feature.activationCode;
              _context2.next = 13;
              return _RegisterInstance["default"].getApplicationInstanceId();

            case 13:
              deviceUuid = _context2.sent;
              userid = feature.userId;
              password = _config["default"].defaultPassword;

              if (!_config["default"].useDrupalContent) {
                _context2.next = 23;
                break;
              }

              _context2.next = 19;
              return _RegisterInstance["default"].getAccessToken('mail:send');

            case 19:
              token = _context2.sent;
              auth = "Bearer ".concat(token);
              _context2.next = 24;
              break;

            case 23:
              auth = 'Basic ' + btoa(user + ':' + password);

            case 24:
              if (!(!user || !requestCode || !deviceUuid || !userid)) {
                _context2.next = 27;
                break;
              }

              console.error("Question2, senUserFeedback: missing required args to post feedback ", user, requestCode, deviceUuid, userid);
              return _context2.abrupt("return");

            case 27:
              _context2.prev = 27;
              _context2.next = 30;
              return _GameService["default"].postUserFeedback(requestCode, deviceUuid, userid, _this.userFeedbackSubject, _this.getFeedbackMessageBody(), 'question', auth);

            case 30:
              _context2.next = 32;
              return (0, _TimeoutHelper.timeout)(100);

            case 32:
              _this.calculateAnswerBoxMaxHeight();

              _this.userEmail = '';
              _this.userFeedbackMessage = '';
              _context2.next = 40;
              break;

            case 37:
              _context2.prev = 37;
              _context2.t0 = _context2["catch"](27);

              _this.onUserFeedbackButtonClicked((0, _ErrorHelper.getErrorMessage)(_context2.t0));

            case 40:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[27, 37]]);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setUserFeedbackMessage", function (event) {
      if (event && event.target) {
        _this.userFeedbackMessage = event.target.value;
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setUserEmail", function (event) {
      if (event && event.target) {
        _this.userEmail = event.target.value;
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "zoomText", function (text, isQuestion, id) {
      var el = document.getElementById(id);

      if (el) {
        var rect = el.getBoundingClientRect();

        if (_this.state.answerStatus === ANSWER_STATUS.UNANSWERED) {
          _this.setState({
            zoomDivPosition: rect,
            textZoomed: true,
            textToZoom: _StringHelper["default"].removeLeadingAndTrailingBrAndPInHtml(text),
            isZoomedQuestion: isQuestion
          }, function () {
            var _getZoomTransform = (0, _Question2HelperFuncs.getZoomTransform)(rect, isQuestion),
                _getZoomTransform2 = (0, _slicedToArray2["default"])(_getZoomTransform, 2),
                scale = _getZoomTransform2[0],
                transform = _getZoomTransform2[1];

            setTimeout(function () {
              _this.setState({
                zoomTransform: transform,
                zoomScale: scale
              });

              setTimeout(function () {
                _this.setState({
                  zoomFinished: true
                });

                setTimeout(function () {
                  _this.setState({
                    animationFinished: true
                  });
                }, 500);
              }, 500);
            }, 500);
          });
        }
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "handleScrolling", function () {
      var element = _this.refDivScroll ? _this.refDivScroll.current : null;

      if (element && element.offsetHeight + element.scrollTop + 20 >= element.scrollHeight && !_this.scrollIndicatorHidden) {
        _this.scrollIndicatorHidden = true;
        setTimeout(function () {
          _this.setState({
            scrollIndicatorHidden: true
          });
        }, 100);
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onTouch", function () {
      var element = _this.refDivScroll ? _this.refDivScroll.current : null;

      if (element) {
        element.scrollTop += 220;
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setIntervalHandle", function () {
      _this.interval = setInterval(_this.onTouch, 10);

      _this.onTouch();
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "handleScrollingAnswersBox", function () {
      var element = _this.refAnswerScroll ? _this.refAnswerScroll.current : null;

      if (element && element.offsetHeight + element.scrollTop + 12 >= element.scrollHeight && !_this.scrollIndicatorHidden) {
        _this.scrollIndicatorHidden = true;
        setTimeout(function () {
          _this.setState({
            scrollIndicatorHidden: true
          });
        }, 100);
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onTouchAnswers", function () {
      var element = _this.refAnswerScroll ? _this.refAnswerScroll.current : null;

      if (element) {
        element.scrollTop += 10;
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "scrollAnswerFromContainer", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(e) {
        var eToUse, delta, answerEl;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('onMouseWheel called'); // cross-browser wheel delta

                eToUse = window.event || e; // old IE support

                delta = eToUse.wheelDelta ? eToUse.deltaY : -eToUse.detail;
                answerEl = _this.refAnswerScroll ? _this.refAnswerScroll.current : null;

                if (answerEl && _this.useEventListenerForAnswerScrolling) {
                  answerEl.scrollTop += delta / 2;
                }

                console.log('onMouseWheel called from container ', eToUse, delta);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "handleScrollingQuestionBox", function () {
      var element = _this.refQuestionScroll ? _this.refQuestionScroll.current : null;

      if (element && element.offsetHeight + element.scrollTop + 12 >= element.scrollHeight) {
        setTimeout(function () {
          _this.setState({
            questionScrollIndicatorHidden: true
          });
        }, 100);
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onTouchQuestions", function () {
      var element = _this.refQuestionScroll ? _this.refQuestionScroll.current : null;

      if (element) {
        element.scrollTop += 10;
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "focusInput", function () {
      (0, _Question2HelperFuncs.focusElement)("".concat(_AnswersBox.TEXTFIELD_ID).concat(_this.props.question.number));

      _this.setState({
        textfieldFocusedBefore: true
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "calculateAnswerBoxMaxHeight", function () {
      var questionBoxFrameId = "questionText_".concat(_this.props.question.number);
      var answerBoxFrameId = "answers_question_".concat(_this.props.question.number);
      var questionEl = document.getElementById(questionBoxFrameId);
      var answerEl = document.getElementById(answerBoxFrameId);
      var questionHeight = 0;
      var frameEl = document.getElementById(_this.props.parentDomId);

      if (questionEl) {
        questionHeight = questionEl.offsetHeight;

        _this.setState({
          questionBoxHeight: questionHeight
        });
      }

      if (answerEl && questionHeight > 0 && frameEl) {
        console.log('calculateAnswerBoxMaxHeight', _this.props.question.number, frameEl.offsetHeight, questionHeight); // - 30 px for margin at the top

        answerEl.style.height = "".concat(frameEl.offsetHeight - questionHeight - 30, "px");
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setTextfieldFocused", function () {
      _this.setState({
        textfieldFocusedBefore: true
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "renderLearnedFeedback", function () {
      var strings = ['Yeah! Das hast Du jetzt gelernt!', 'Ausgezeichnet! Das weißt Du jetzt!', 'Sehr gut! Wieder ein Frage gelernt!', 'Yippie! Eine weitere Frage, die jetzt abgehakt ist!', 'Gelernt. Weiter so!', 'Zack - Frage gelernt! Weiter geht’s.', 'Jawoll - Gelernt!', 'Hurra - Das weißt Du jetzt!', 'SUPER - Frage erledigt!', 'Fakten über Fakten – Diese kennst du jetzt.', 'Supercalifragilisticexpialigetisch! Weiter so.', 'Und wieder eine Frage gelernt!', 'Hervorragend – und wieder hast Du einen Fakt drauf!', 'Sehr gut – Du gehst ja ab wie eine Rakete!', 'Mega – Das weißt Du jetzt!', 'Na aber hallo! Gut gelernt, weiter geht’s!'];
      var rand = Math.floor(Math.random() * strings.length);
      var images = [require('./assets/1.gif'), require('./assets/2.gif'), require('./assets/3.gif'), require('./assets/4.gif'), require('./assets/5.gif'), require('./assets/6.gif'), require('./assets/7.gif'), require('./assets/8.gif'), require('./assets/9.gif'), require('./assets/10.gif')];
      var imgRand = Math.floor(Math.random() * images.length);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, strings[rand]), /*#__PURE__*/_react["default"].createElement("img", {
        className: _Question["default"].giffy,
        alt: "",
        src: images[imgRand]
      }));
    });
    var hasExposition = (props.question.sequence in props.sequences);
    var showExposition = hasExposition && props.question.isFirstInSequence;
    _this.refDivScroll = /*#__PURE__*/_react["default"].createRef();
    _this.refContainerScroll = /*#__PURE__*/_react["default"].createRef();
    _this.refAnswerScroll = /*#__PURE__*/_react["default"].createRef();
    _this.refQuestionScroll = /*#__PURE__*/_react["default"].createRef();
    _this.refQuestionScrollText = /*#__PURE__*/_react["default"].createRef();
    _this.state = {
      imgOverlay: false,
      imgLink: '',
      showOverlay: 'none',
      showLargeImage: false,
      answerStatus: ANSWER_STATUS.UNANSWERED,
      timerBarStopped: true,
      timerBarStoppedByExpositionButton: false,
      overlay: {
        width: '100%',
        // DeviceInfoHelper.isBrowser() || this.props.isInKesi ? '100%' : window.innerWidth,
        height: window.innerHeight
      },
      startTime: null,
      pauseStart: null,
      endTime: null,
      feedbackHidden: false,
      specificFeedbackHidden: true,
      fontSize: null,
      fontSizeQuestion: null,
      textZoomed: false,
      textToZoom: null,
      isZoomedQuestion: false,
      zoomDivPosition: null,
      zoomTransform: null,
      zoomScale: 1,
      zoomFinished: false,
      animationFinished: false,
      scrollIndicatorHidden: !_config["default"].useScrollIndicator,
      questionScrollIndicatorHidden: true,
      selectedAnswers: [],
      hasExposition: hasExposition,
      showExposition: showExposition,
      layoutSetup: false,
      textfieldFocusedBefore: false,
      selfEvaluationAnswer: null,
      questionBoxHeight: 0,
      questionScrollingDisabled: false,
      questionLearned: false,
      showMCAlert: false,
      sendMC: false
    };
    _this._scrollIndicatorHidden = !_config["default"].useScrollIndicator;
    _this.useEventListenerForAnswerScrolling = true;
    _this.feedbackIsClosing = false;
    _this.bestQuestionFontSize = null;
    _this.bestAnswerFontSize = null;
    _this.userFeedbackSubject = (0, _QuizStrings.getString)('DEFAULT_USER_FEEDBACK_SUBJECT');
    _this.userFeedbackMessage = '';
    _this.userEmail = '';
    _this.isGoingToNextQuestion = false;
    _this.feedbackReceivedTimeouts = [];
    _this.interval = null;
    _this.selfEvaluationScore = 0;
    _this.specificFeedback = "";
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(Question.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStorePaths.DATA_STORE_PATHS.QD_USER, _DataStorePaths.DATA_STORE_PATHS.QD_GAME, _DataStorePaths.DATA_STORE_PATHS.QD_GROUP, _DataStorePaths.DATA_STORE_PATHS.QD_SELECTED_OPPONENT, _DataStorePaths.DATA_STORE_PATHS.CONNECT_PARTNER_IDS, _DataStorePaths.DATA_STORE_PATHS.QD_CURRENT_QUESTION_STATUS, _DataStorePaths.DATA_STORE_PATHS.QD_HISTORY_BASED_FEEDBACK, _DataStorePaths.DATA_STORE_PATHS.QD_CURRENT_QUESTION_STATUS_NUMBER, _DataStorePaths.DATA_STORE_PATHS.QD_GROUP_ID, _DataStorePaths.DATA_STORE_PATHS.QD_GROUP_HIDE_FEEDBACK, _DataStorePaths.DATA_STORE_PATHS.QD_CURRENT_ROUND_STATES, _DataStorePaths.DATA_STORE_PATHS.QD_GAME_ROUNDS]);
    (0, _get2["default"])((_thisSuper2 = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(Question.prototype)), "addStoresAndKeys", _thisSuper2).call(_thisSuper2, [{
      store: _ThemeStore["default"],
      keys: ['currentTheme', 'quiz']
    }]);
    _this.canAnswer = false;
    _this.scrollIndicatorHidden = false;
    _this.selectedAnswers = [];
    _this.questionStyles = null;
    return _this;
  }

  (0, _createClass2["default"])(Question, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      (0, _AppUtils.registerForAblyMessagesWithcommand)(_AblyMessagingCommands.ABLY_COMMANDS.FEEDBACK_TAGS_RECEIVED, this.handleTagReceivedMessage);

      if (this.props.setTitle) {
        this.props.setTitle("".concat(this.props.question.category.name));
      }

      setTimeout(function () {
        _this2.canAnswer = true;

        if (_this2.props.isSinglePlayer && _this2.props.reviewMode && _this2.props.selectedAnswers) {
          _this2.onSelectAnswer(_this2.props.selectedAnswers);
        }
      }, 100);

      if (!this.props.isSinglePlayer && this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_USER] && this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_SELECTED_OPPONENT]) {
        (0, _QDGroupService.updateQDPresence)(this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_USER].nickname, this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_GROUP_ID], {
          opponent: this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_SELECTED_OPPONENT].id,
          round: this.props.currentRound,
          question: this.props.question.number
        });
      }

      if (this.state.showExposition && this.props.question.number === 0 && this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_CURRENT_QUESTION_STATUS].number === this.props.question.number) {
        var button = {
          label: (0, _QuizStrings.getString)('OK'),
          callback: function callback() {
            _this2.setQuestionStartTime();

            _this2.setState({
              showExposition: false,
              timerBarStopped: _this2.state.answerStatus === ANSWER_STATUS.UNANSWERED ? false : _this2.state.timerBarStopped,
              timerBarStoppedByExpositionButton: false
            });
          }
        };
        console.log('DEBUG showing exposition in didMount');
        (0, _AlertHelper.showAlertWithOptions)({
          html: this.props.sequences[this.props.question.sequence].exposition,
          title: this.getExpositionHeading(),
          showCloseButton: false,
          buttons: [button],
          size: 'large'
        }); // showWideAlertHtml(this.props.sequences[this.props.question.sequence].exposition, this.getExpositionHeading(), false, [button], false)
      }

      if (this.props.isSinglePlayer && !this.props.disableTimer) {
        this.setState({
          startTime: (0, _now["default"])()
        });
      }

      if (this.refAnswerScroll && this.refAnswerScroll.current) {
        this.refAnswerScroll.current.addEventListener('scroll', this.checkIfScrollingNeeded);
      }

      if (this.refContainerScroll && this.refContainerScroll.current) {
        this.refContainerScroll.current.addEventListener('wheel', this.scrollAnswerFromContainer);
      }

      setTimeout(function () {
        _this2.setState({
          layoutSetup: true
        });
      }, 0);
      setTimeout(function () {
        _this2.checkIfScrollingNeeded();
      }, 500);

      _ScreenHelper["default"].instance().addOnWindowSizeChangedListener(this.resetFontSizes);

      this.setTimerBarRenderFn();
      console.log('MY GAME: ', this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_GAME]);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _AppUtils.unregisterFromAblyMessagesWithcommand)(_AblyMessagingCommands.ABLY_COMMANDS.FEEDBACK_TAGS_RECEIVED, this.handleTagReceivedMessage);

      if (window.screen.orientation) {
        window.screen.orientation.removeEventListener('change', this.innerForceUpdate);
      }

      if (this.refAnswerScroll && this.refAnswerScroll.current) {
        this.refAnswerScroll.current.removeEventListener('scroll', this.checkIfScrollingNeeded);
      }

      if (this.refContainerScroll && this.refContainerScroll.current) {
        this.refContainerScroll.current.removeEventListener('wheel', this.scrollAnswerFromContainer);
      }

      if (this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_USER] && this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_SELECTED_OPPONENT] && !this.props.isSinglePlayer) {
        (0, _QDGroupService.updateQDPresence)(this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_USER].nickname, this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_GROUP_ID], {
          opponent: this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_SELECTED_OPPONENT].id,
          round: null,
          question: null
        });
      }

      _ScreenHelper["default"].instance().removeOnWindowSizeChangedListener(this.resetFontSizes);

      (0, _get2["default"])((0, _getPrototypeOf2["default"])(Question.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this3 = this;

      if (!this.state.feedbackHidden && this.hasFeedback()) {
        var element = this.refDivScroll ? this.refDivScroll.current : null;
        var innerDiv = document.getElementById('feedbackDiv');

        if (element && element.scrollHeight <= element.offsetHeight && this.scrollIndicatorHidden === false) {
          this.setState({
            scrollIndicatorHidden: true
          }); // this.setState({scrollIndicatorHidden: true})
        } else if (element && innerDiv && innerDiv.offsetHeight < element.offsetHeight) {
          element.style.minHeight = innerDiv.style.height + '5px';
        }
      }

      if (this.props.isSinglePlayer && !this.props.disableTimer && this.props.question !== prevProps.question) {
        // Add a litle bit of delay for switching to the new question
        this.setState({
          startTime: (0, _now["default"])() + 500,
          timerBarStopped: false
        });
      }

      if (this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_CURRENT_QUESTION_STATUS_NUMBER] !== prevState.data[_DataStorePaths.DATA_STORE_PATHS.QD_CURRENT_QUESTION_STATUS_NUMBER] && this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_CURRENT_QUESTION_STATUS_NUMBER] === prevProps.question.number) {
        this.props.setTitle("".concat(this.props.question.category.name)); // nextProps.setTitle(`${getString('QUESTION')} ${nextProps.question.number + 1} ${nextProps.question.category.name}`)

        (0, _QDGroupService.updateQDPresence)(prevState.data[_DataStorePaths.DATA_STORE_PATHS.QD_USER].nickname, prevState.data[_DataStorePaths.DATA_STORE_PATHS.QD_GROUP_ID], {
          opponent: prevState.data[_DataStorePaths.DATA_STORE_PATHS.QD_SELECTED_OPPONENT].id,
          round: prevProps.currentRound,
          question: this.props.question.number + 1
        });
        this.setState({
          startTime: (0, _now["default"])(),
          answerStatus: ANSWER_STATUS.UNANSWERED,
          showOverlay: 'none',
          questionLearned: false
        });

        if (prevState.showExposition) {
          var button = {
            label: (0, _QuizStrings.getString)('OK'),
            callback: function callback() {
              _this3.setQuestionStartTime();

              _this3.setState({
                showExposition: false,
                timerBarStopped: prevState.answerStatus === ANSWER_STATUS.UNANSWERED ? false : prevState.timerBarStopped,
                timerBarStoppedByExpositionButton: false
              });
            }
          };
          (0, _AlertHelper.showAlertWithOptions)({
            html: this.props.sequences[prevProps.question.sequence].exposition,
            title: this.getExpositionHeading(),
            showCloseButton: false,
            buttons: [button]
          }); // showWideAlertHtml(this.props.sequences[this.props.question.sequence].exposition, this.getExpositionHeading(), false, [button], false)
        }
      }

      if (this.state.fontSize !== prevState.fontSize) {
        this.questionStyles = null;
        this.forceUpdate();
      }
    }
  }, {
    key: "setState",
    value: function setState(state, callback) {
      var _this4 = this;

      (0, _get2["default"])((0, _getPrototypeOf2["default"])(Question.prototype), "setState", this).call(this, state, function () {
        if (_this4.props.onTimerBarStateUpdate && (state.startTime || state.duration || state.timerBarStopped)) {
          _this4.props.onTimerBarStateUpdate();
        }

        if (callback) {
          callback();
        }
      });
    }
  }, {
    key: "setTimerBarRenderFn",
    value: function setTimerBarRenderFn() {
      var _this5 = this;

      if (!this.props.isInKesi && this.props.setRenderTimerBarFn) {
        this.props.setRenderTimerBarFn(function () {
          return /*#__PURE__*/_react["default"].createElement(_index2["default"], {
            questionNumber: _this5.props.question.number,
            editorMode: _this5.props.editorMode,
            startTime: _this5.props.editorMode ? (0, _now["default"])() - _this5.props.question.duration * 1000 * 0.6 : _this5.state.startTime,
            duration: _this5.props.question.duration * 1000,
            className: "".concat(_Question["default"].timer),
            onTimeOver: _this5.onTimeOver,
            running: !_this5.state.timerBarStopped,
            startDelay: _this5.props.isSinglePlayer ? 0 : 800
          });
        });
      }
    }
  }, {
    key: "onFontSizeSetForAnswers",

    /**
     * Answers may consist only of an images so there is no font size needed.
     * Default
     * @param bestSize
     * @returns {Promise<void>}
     */
    value: function () {
      var _onFontSizeSetForAnswers = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(bestSize) {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.bestAnswerFontSize = bestSize || 16;

                if (this.bestQuestionFontSize) {
                  this.setState({
                    // fontSize: Math.min(this.bestAnswerFontSize, this.bestQuestionFontSize)
                    fontSize: this.bestAnswerFontSize,
                    fontSizeQuestion: this.bestQuestionFontSize
                  });
                  this.setQuestionStartTime();
                }

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function onFontSizeSetForAnswers(_x2) {
        return _onFontSizeSetForAnswers.apply(this, arguments);
      }

      return onFontSizeSetForAnswers;
    }()
  }, {
    key: "onFontSizeSetForQuestion",
    value: function () {
      var _onFontSizeSetForQuestion = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(bestSize) {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.bestQuestionFontSize = bestSize || 16; // some question types don't have any answer text

                if (this.bestAnswerFontSize || this.props.question.type === QUESTION_TYPES.VALNUM || this.props.question.type === QUESTION_TYPES.VALSTR || this.props.question.type === QUESTION_TYPES.SE) {
                  console.log('the Font has been found', this.bestAnswerFontSize, this.bestQuestionFontSize);
                  this.setState({
                    // fontSize: Math.min(this.bestAnswerFontSize, this.bestQuestionFontSize)
                    fontSize: this.bestAnswerFontSize || 16,
                    fontSizeQuestion: this.bestQuestionFontSize
                  });
                  this.setQuestionStartTime();
                }

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function onFontSizeSetForQuestion(_x3) {
        return _onFontSizeSetForQuestion.apply(this, arguments);
      }

      return onFontSizeSetForQuestion;
    }()
  }, {
    key: "isMCQuestion",
    value: function isMCQuestion() {
      return this.props.question.type === QUESTION_TYPES.MC;
    }
  }, {
    key: "getDefaultFeedback",
    value: function getDefaultFeedback() {
      return this.hasDefaultFeedback() ? this.props.question.feedback : null;
    }
  }, {
    key: "hasFeedback",
    value: function hasFeedback() {
      if (this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_GROUP_HIDE_FEEDBACK]) {
        return null;
      }

      if (this.props.question.type === QUESTION_TYPES.SE) {
        return null;
      } // if (this.props.question.type === QUESTION_TYPES.MC && !target.isEqueoQdErgo && !this.state.questionLearned) {
      //   // handled in AnswersBox2
      //   return null
      // }


      return this.state.questionLearned || this.hasDefaultFeedback() || this.hasAnswerSpecificFeedback() || this.hasFreetextAnswerSpecificFeedback() || this.hasHistoryBasedFeedback();
    }
  }, {
    key: "hasSelfEvaluation",
    value: function hasSelfEvaluation() {
      return this.props.question.type === QUESTION_TYPES.SE;
    }
  }, {
    key: "getMCFeedback",
    value: function getMCFeedback() {
      var _this6 = this;

      if (!this.isMCQuestion()) {
        return null;
      }

      var answersRendered = this.props.question.answers.map(function (answer) {
        var color = answer.isCorrect ? 'green' : 'red';
        var answerToUse = answer.answer;
        var mathMl = null;

        if (_DeviceInfoHelper["default"].isAndroid() && _MathJaxHelper["default"]) {
          mathMl = _StringHelper["default"].getMathMlContent(answer.answer);

          if (mathMl && mathMl.length > 0) {
            answerToUse = answer.answer.replace(mathMl[0], '');
          }
        }

        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            color: color,
            textAlign: 'left',
            paddingTop: 2,
            paddingBottom: 2
          },
          key: "answer_".concat(answer.number)
        }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          style: {
            color: color
          },
          checked: _this6.state.selectedAnswers.includes(answer.number)
        }), !mathMl && /*#__PURE__*/_react["default"].createElement("span", {
          dangerouslySetInnerHTML: {
            __html: _StringHelper["default"].removeLeadingAndTrailingBrAndPInHtml(answerToUse)
          }
        }), mathMl && mathMl[0] && /*#__PURE__*/_react["default"].createElement(_MathJaxHelper["default"], {
          className: _Question["default"].mathJax,
          math: mathMl[0]
        }));
      });
      return answersRendered;
    }
  }, {
    key: "getFreetextAnswerSpecificFeedback",
    value: function getFreetextAnswerSpecificFeedback() {
      if (this.props.question.type !== QUESTION_TYPES.VALNUM && this.props.question.type !== QUESTION_TYPES.VALSTR) {
        return null;
      }

      var feedbackToUse = null;

      if (this.selectedAnswers.length > 0 || this.state.answerStatus === ANSWER_STATUS.TIME_OVER) {
        var answerParts = JSON.parse(this.props.question.answers[0].answer);
        var userAnswer = this.selectedAnswers[0] || {
          number: 0,
          bestCorrectAnswer: answerParts[0]
        };
        var detailedFeedback = this.props.question.detailedFeedback[userAnswer.number];
        console.log('getFreetextAnswerSpecificFeedback', detailedFeedback, userAnswer);

        if (detailedFeedback) {
          if (userAnswer.almostCorrect) {
            feedbackToUse = detailedFeedback.approx || this.props.question.feedback;
          } else if (userAnswer.isCorrect) {
            feedbackToUse = detailedFeedback.correct;
          } else {
            feedbackToUse = detailedFeedback.wrong || this.props.question.feedback;
          }
        } else if (!userAnswer.isCorrect) {
          feedbackToUse = this.props.question.feedback;
        }

        if (feedbackToUse) {
          if (feedbackToUse.html) {
            feedbackToUse = feedbackToUse.html;
          }

          feedbackToUse = feedbackToUse.replace(/({[Nn][Uu][Tt][Zz][Ee][Rr][Aa][Nn][Tt][Ww][Oo][Rr][Tt]}|{[Uu][Ss][Ee][Rr][Ii][Nn][Pp][Uu][Tt]})/g, userAnswer.text) // {userinput} or {nutzerantwort}
          .replace(/({[Cc][Oo][Rr][Rr][Ee][Cc][Tt]}|{[Rr][Ii][Cc][Hh][Tt][Ii][Gg]})/g, userAnswer.bestCorrectAnswer); // {correct} or {richtig}
        }
      }

      return feedbackToUse;
    }
  }, {
    key: "getAnswerSpecificFeedback",
    value: function getAnswerSpecificFeedback() {
      var _this7 = this;

      if (!this.state.selectedAnswers && !((this.props.question.type === QUESTION_TYPES.VALSTR || this.props.question.type === QUESTION_TYPES.VALNUM) && this.state.answerStatus === ANSWER_STATUS.TIME_OVER)) {
        return null;
      }

      if (this.props.question.type === QUESTION_TYPES.SE) {
        return null;
      }

      if (this.isMCQuestion()) {
        // no detailed feedback for MC questions for now
        return null;
      }

      var showGenericFeedback = this.state.selectedAnswers.some(function (answerNumber) {
        return !_this7.isAnswerCorrect(answerNumber) && !_this7.hasAnswerSpecificFeedback(answerNumber);
      });
      var feedback = '';

      if (showGenericFeedback) {
        feedback += "".concat(this.props.question.feedback, "<br/><br/>");
      }

      this.state.selectedAnswers.forEach(function (answerNumber) {
        if (_this7.hasAnswerSpecificFeedback(answerNumber) && _this7.props.question.detailedFeedback[answerNumber] && _this7.props.question.detailedFeedback[answerNumber].html) {
          feedback += "".concat(_this7.props.question.detailedFeedback[answerNumber].html, "<br/><br/>");
        } else if (_this7.hasAnswerSpecificFeedback(answerNumber) && !_this7.props.question.detailedFeedback[answerNumber].html) {
          feedback += "".concat(_this7.props.question.detailedFeedback[answerNumber], "<br/><br/>");
        }
      });
      return feedback.length > 0 ? feedback : null;
    }
  }, {
    key: "hasFreetextAnswerSpecificFeedback",
    value: function hasFreetextAnswerSpecificFeedback() {
      return this.getFreetextAnswerSpecificFeedback() !== null;
    }
  }, {
    key: "hasAnswerSpecificFeedback",
    value: function hasAnswerSpecificFeedback() {
      var _this8 = this;

      var answerNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var answerNumbers = answerNumber ? [answerNumber] : this.state.selectedAnswers;
      return this.state.answerStatus !== ANSWER_STATUS.UNANSWERED && this.props.question.detailedFeedback && answerNumbers.some(function (num) {
        return _this8.props.question.detailedFeedback[num];
      });
    }
  }, {
    key: "hasDefaultFeedback",
    value: function hasDefaultFeedback() {
      return this.props.question.feedback && this.props.question.type !== QUESTION_TYPES.SE && (this.state.answerStatus === ANSWER_STATUS.WRONG || this.state.answerStatus === ANSWER_STATUS.TIME_OVER);
    }
  }, {
    key: "hasHistoryBasedFeedback",
    value: function hasHistoryBasedFeedback() {
      return _config["default"].useHistoryBasedFeedback && this.state.answerStatus !== ANSWER_STATUS.UNANSWERED && this.props.question.learningDistance.history && this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_HISTORY_BASED_FEEDBACK];
    }
  }, {
    key: "getExpositionHeading",
    value: function getExpositionHeading() {
      return this.props.sequences[this.props.question.sequence].heading || 'Erklärung';
    }
  }, {
    key: "getOpponentsAnswer",
    value: function getOpponentsAnswer(opponent, currentRound, question) {
      var opponentAnswerState = currentRound.state[opponent.playerState];

      if (opponentAnswerState.length > 0) {
        for (var i = 0; i < opponentAnswerState.length; i++) {
          if (opponentAnswerState[i].number === question.number) {
            return opponentAnswerState[i].value;
          }
        }
      }

      return null;
    }
  }, {
    key: "renderExposition",
    value: function renderExposition() {
      return null; // if (!this.state.showExposition) {
      //   return null
      // }
      // return (
      //   <SequenceExposition
      //     sequence={this.props.sequences[this.props.question.sequence]}
      //     captionOverwrite={!this.state.timerBarStoppedByExpositionButton && this.state.answerStatus === ANSWER_STATUS.UNANSWERED ? null : 'Zurück'}
      //     onClose={() => {
      //       this.setQuestionStartTime()
      //       this.setState({
      //         showExposition: false,
      //         timerBarStopped: this.state.answerStatus === ANSWER_STATUS.UNANSWERED ? false : this.state.timerBarStopped,
      //         timerBarStoppedByExpositionButton: false
      //       })
      //     }}
      //   />
      // )
    }
  }, {
    key: "renderExpositionInfoButton",
    value: function renderExpositionInfoButton() {
      var _this9 = this;

      if (!this.state.hasExposition) {
        return null;
      }

      var feedbackVisible = this.state.showOverlay !== 'none' && !this.state.feedbackHidden;
      var style = {
        opacity: feedbackVisible ? 0.2 : 1
      };

      if (feedbackVisible) {
        style.pointerEvents = 'none';
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _Question["default"].expositionInfoButton,
        style: style,
        onClick: function onClick() {
          var button = {
            label: (0, _QuizStrings.getString)('OK'),
            callback: function callback() {
              _this9.setQuestionStartTime();

              _this9.setState({
                showExposition: false,
                timerBarStopped: _this9.state.answerStatus === ANSWER_STATUS.UNANSWERED ? false : _this9.state.timerBarStopped,
                timerBarStoppedByExpositionButton: false
              });
            }
          };
          (0, _AlertHelper.showAlertWithOptions)({
            html: _this9.props.sequences[_this9.props.question.sequence].exposition,
            title: _this9.getExpositionHeading(),
            showCloseButton: false,
            buttons: [button]
          }); // showWideAlertHtml(this.props.sequences[this.props.question.sequence].exposition, this.getExpositionHeading(), false, [button], false)

          _this9.setState({
            showExposition: true,
            timerBarStopped: true,
            timerBarStoppedByExpositionButton: true,
            pauseStart: (0, _now["default"])()
          });
        }
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: require('./assets/info.svg')
      }));
    }
  }, {
    key: "renderUserFeedbackButton",
    value: function renderUserFeedbackButton() {
      var _this10 = this;

      if (this.state.answerStatus === ANSWER_STATUS.UNANSWERED) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_Question["default"].userFeedbackButton, " ").concat(this.state.feedbackHidden ? _Question["default"].atRightBorder : '', " ").concat(_DeviceInfoHelper["default"].isInternetExplorer() ? '' : _Question["default"].notIE),
        onClick: function onClick() {
          return _this10.onUserFeedbackButtonClicked();
        }
      }, /*#__PURE__*/_react["default"].createElement(_ChatBubbleOutline["default"], {
        style: {
          fontSize: 'large'
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this11 = this;

      // const ratio = this.getScreenRatio()
      if (!this.state.startTime || !this.questionStyles || this.props.isInKesi) {
        // update style until question has started.
        this.questionStyles = (0, _QuizRoundStyle.getQuestionStyles)(this.state, this.props.parentDomId, this.props.isSinglePlayer && !_config["default"].isQuizApp && !this.props.isInKesi, this.props.isSinglePlayer, this.props.isInKesi, this.props.question.number);
      }

      var style = this.questionStyles;
      var overlayStyles = (0, _QuizRoundStyle.getQuestionOverlayIconStyles)(this.state, this.hasFeedback(), this.props.isInKesi, _config["default"].allowDifferentQuestionBoxSizes ? style.questionStyle.maxHeight : style.questionStyle.height);
      var paddingStyle = {
        paddingLeft: 0,
        paddingRight: 0
      }; // const answerBoxStyle = Object.assign({opacity: this.state.fontSize ? 1 : 0}, paddingStyle)

      var exposition = this.state.showExposition ? /*#__PURE__*/_react["default"].createElement("div", {
        id: "exposition",
        className: _Question["default"].exposition
      }, this.renderExposition()) : null;
      var hideFeedbackByGroup = this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_GROUP_HIDE_FEEDBACK];
      var showFeedback = !this.state.feedbackHidden && this.hasFeedback(); // only display specific feedback when we have specific && global

      var doNotShowMainFeedback = this.isMCQuestion() && this.props.question.detailedFeedback && (0, _keys["default"])(this.props.question.detailedFeedback).length > 0;
      var showSelfEvaluation = !this.state.feedbackHidden && this.props.question.type === QUESTION_TYPES.SE && (this.state.answerStatus === ANSWER_STATUS.EVALUATION || this.state.answerStatus === ANSWER_STATUS.TIME_OVER);
      var questionBoxFrameId = "questionText_".concat(this.props.question.number);
      var questionBoxOuterFrameId = "questionBoxFrame_".concat(this.props.question.number);
      var answerBoxFrameId = "answers_question_".concat(this.props.question.number);
      var styleOverlay = {
        width: this.props.isInKesi ? null : this.props.isSinglePlayer ? '100%' : this.state.overlay.width,
        height: this.props.isInKesi ? '100%' : this.props.isSinglePlayer ? '100%' : this.state.overlay.height,
        display: this.state.showOverlay
      };

      if (!_config["default"].showOnlyQuestionOverlay && this.state.feedbackHidden && this.state.specificFeedbackHidden && (this.props.question.type === QUESTION_TYPES.MC || this.props.question.type === QUESTION_TYPES.SC)) {
        // after closing the feedback overlay, the user must be able to scroll the original answer proposal
        // it works out of the box on iOS but not on android
        // so we have to remove the overlay and add different click handlers to the questions and each answer
        // the rare remaingin space is not leading to the next question then
        styleOverlay.display = 'none';
      }

      var timerBarExtraClassNames = '';

      if (this.props.isInKesi) {
        if (_config["default"].showLectureHeader) {
          timerBarExtraClassNames = _Question["default"].timerKesiWithHeader;
        } else if (this.props.isSinglePlayer) {
          if (this.props.hasChooser) {
            timerBarExtraClassNames = _Question["default"].timerKesiSinglePlayer;
          } else {
            timerBarExtraClassNames = _Question["default"].timerKesiSinglePlayerWithoutChooser;
          }
        } else {
          timerBarExtraClassNames = _Question["default"].timerKesiWithoutHeader;
        }
      }

      var kesiTimerBar = this.props.isInKesi && (this.state.data[_DataStorePaths.DATA_STORE_PATHS.QD_CURRENT_QUESTION_STATUS_NUMBER] === this.props.question.number || this.props.isSinglePlayer && !this.props.disableTimer) ? /*#__PURE__*/_react["default"].createElement(_index2["default"], {
        editorMode: this.props.editorMode,
        startTime: this.props.editorMode ? (0, _now["default"])() - this.props.question.duration * 1000 * 0.6 : this.state.startTime,
        duration: this.props.question.duration * 1000,
        className: "".concat(_Question["default"].timer, " ").concat(timerBarExtraClassNames),
        onTimeOver: this.onTimeOver,
        running: !this.state.timerBarStopped,
        startDelay: this.props.isSinglePlayer ? 0 : 800
      }) : null;
      var interceptClickInMCAndSCQuestions = this.state.feedbackHidden && (this.props.question.type === QUESTION_TYPES.MC || this.props.question.type === QUESTION_TYPES.SC);
      var answersClassName;

      if (this.props.question.type === QUESTION_TYPES.MC || this.props.question.type === QUESTION_TYPES.SC) {
        answersClassName = "".concat(_Question["default"].answerContainer_list, " ").concat(this.props.isSinglePlayer ? _Question["default"].trainingMode : '');
      } else {
        answersClassName = this.props.isInKesi ? "".concat(_Question["default"].answerContainer, " ").concat(_Question["default"].browser) : _Question["default"].answerContainer;
      }

      this.calculateAnswerBoxMaxHeight();
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.refContainerScroll,
        style: {
          height: '100%'
        }
      }, kesiTimerBar, /*#__PURE__*/_react["default"].createElement("div", {
        style: style.outerBoxStyle
      }, exposition, /*#__PURE__*/_react["default"].createElement("div", {
        id: questionBoxOuterFrameId,
        style: (0, _assign["default"])({
          overflow: 'hidden'
        }, style.boxStyle)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: questionBoxFrameId,
        className: _config["default"].allowDifferentQuestionBoxSizes && !this.state.questionScrollingDisabled ? _Question["default"].questionScrollable : this.props.isInKesi ? _Question["default"].questionKesi : _Question["default"].question,
        style: style.questionStyle,
        ref: this.refQuestionScroll,
        onScroll: this.handleScrollingQuestionBox,
        onClick: interceptClickInMCAndSCQuestions ? function () {
          if (_config["default"].allowDifferentQuestionBoxSizes) {
            var el = document.getElementById(questionBoxFrameId);

            if (el) {
              el.scrollTop = 0;
            }
          }

          _this11.setState({
            specificFeedbackHidden: true,
            feedbackHidden: false,
            questionScrollingDisabled: true
          });
        } : null
      }, _config["default"].showOnlyQuestionOverlay ? /*#__PURE__*/_react["default"].createElement("div", {
        id: "overlay",
        className: _Question["default"].overlay,
        style: styleOverlay,
        onClick: showSelfEvaluation ? function () {} : function () {
          if (!_this11.hasSelfEvaluation()) {
            if (_this11.hasFeedback()) {
              if (_config["default"].allowDifferentQuestionBoxSizes) {
                var el = document.getElementById(questionBoxFrameId);

                if (el) {
                  el.scrollTop = 0;
                }
              }

              _this11.setState({
                specificFeedbackHidden: true,
                feedbackHidden: false,
                questionScrollingDisabled: true
              });
            } else {
              _this11.onNextQuestion(true);
            }
          }
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: hideFeedbackByGroup ? _Question["default"].overlayContainerInvisible : this.state.feedbackHidden ? _Question["default"].overlayContainerFeedbackMode : _Question["default"].overlayContainer,
        style: {
          width: this.state.overlay.width,
          height: 'calc(100% + 20px)',
          display: this.state.showOverlay || showSelfEvaluation
        }
      })) : null, this.state.layoutSetup ? /*#__PURE__*/_react["default"].createElement(_QuestionBox["default"], {
        scrollRef: this.refQuestionScrollText,
        editorMode: this.props.editorMode,
        question: this.props.question,
        showImageOverlay: this.showImageOverlay,
        fontSize: this.state.fontSizeQuestion,
        onPerfectFontSizeFound: function onPerfectFontSizeFound(size) {
          return _this11.onFontSizeSetForQuestion(size);
        },
        mustFitToDomWithId: questionBoxFrameId,
        zoomText: this.zoomText,
        frameId: questionBoxFrameId,
        containerHeight: _config["default"].allowDifferentQuestionBoxSizes ? this.state.questionHeight > 0 ? this.state.questionHeight : style.questionStyle.maxHeight : style.questionStyle.height,
        showScrollIndicator: this.state.answerStatus === ANSWER_STATUS.UNANSWERED && !this.state.questionScrollIndicatorHidden && _config["default"].useScrollIndicator,
        onTouchQuestions: this.onTouchQuestions
      }) : null, this.state.layoutSetup ? this.renderExpositionInfoButton() : null), /*#__PURE__*/_react["default"].createElement("div", {
        id: answerBoxFrameId,
        className: answersClassName,
        ref: this.refAnswerScroll,
        onScroll: this.handleScrollingAnswersBox // onMouseEnter={() => {
        //   this.useEventListenerForAnswerScrolling = false
        //   console.log('MOUSEENTER evt', this.useEventListenerForAnswerScrolling)
        // }}
        // onMouseLeave={() => {
        //   this.useEventListenerForAnswerScrolling = true
        //   console.log('MOUSELEAVE evt', this.useEventListenerForAnswerScrolling)
        // }}
        //  onScroll={this.handleScrolling}
        // className={`${ownStyles.answerContainer} ${DeviceInfoHelper.isBrowser() ? ownStyles.browser : ''}`}
        ,
        style: paddingStyle
      }, this.state.layoutSetup ? /*#__PURE__*/_react["default"].createElement(_AnswersBox["default"], {
        showSpecificFeedback: this.showSpecificFeedback,
        selectedAnswers: this.props.selectedAnswers,
        reviewMode: this.props.reviewMode,
        editorMode: this.props.editorMode,
        question: this.props.question,
        styles: style,
        classes: _Question["default"],
        onSelectAnswer: this.props.disableAnswers ? this.props.onSubmitAnswer : this.onSelectAnswer,
        fontSize: this.state.fontSize,
        onPerfectFontSizeFound: function onPerfectFontSizeFound(size) {
          return _this11.onFontSizeSetForAnswers(size);
        },
        zoomText: this.zoomText,
        showScrollIndicator: (this.props.question.type === QUESTION_TYPES.MC || this.props.question.type === QUESTION_TYPES.SC) && this.state.answerStatus === ANSWER_STATUS.UNANSWERED && !this.state.scrollIndicatorHidden && _config["default"].useScrollIndicator,
        onTouchAnswers: this.onTouchAnswers,
        questionAnswered: this.state.answerStatus !== ANSWER_STATUS.UNANSWERED,
        disabled: interceptClickInMCAndSCQuestions,
        textfieldFocusedBefore: this.state.textfieldFocusedBefore,
        onSelfEvaluation: this.onSelfEvaluation,
        disableAnswers: this.props.disableAnswers,
        onNextQuestion: this.props.onSubmitAnswer,
        setTextfieldFocused: this.setTextfieldFocused,
        showFeedbackFn: function showFeedbackFn() {
          return _this11.setState({
            specificFeedbackHidden: true,
            feedbackHidden: false,
            questionScrollingDisabled: true
          });
        },
        isInKesi: this.props.isInKesi,
        isTimeOver: this.state.answerStatus === ANSWER_STATUS.TIME_OVER,
        setMCAlert: this.setMCAlert,
        unsetMCAlert: this.unsetMCAlert,
        sendMC: this.state.sendMC
      }) : null)), _config["default"].showOnlyQuestionOverlay ? null : /*#__PURE__*/_react["default"].createElement("div", {
        id: "overlay",
        className: _Question["default"].overlay,
        style: _config["default"].showOnlyQuestionOverlay ? (0, _assign["default"])({}, styleOverlay) : styleOverlay,
        onClick: showSelfEvaluation ? function () {} : function () {
          if (!_this11.hasSelfEvaluation()) {
            if (_this11.hasFeedback()) {
              if (_config["default"].allowDifferentQuestionBoxSizes) {
                var el = document.getElementById(questionBoxFrameId);

                if (el) {
                  el.scrollTop = 0;
                }
              }

              _this11.setState({
                specificFeedbackHidden: true,
                feedbackHidden: false,
                questionScrollingDisabled: true
              });
            } else {
              _this11.onNextQuestion(true);
            }
          }
        }
      }, !this.state.feedbackHidden && /*#__PURE__*/_react["default"].createElement("div", {
        className: hideFeedbackByGroup ? _Question["default"].overlayContainerInvisible : this.state.feedbackHidden ? _Question["default"].overlayContainerFeedbackMode : _Question["default"].overlayContainer,
        style: {
          width: this.state.overlay.width,
          height: 'calc(100% + 20px)',
          display: this.state.showOverlay || showSelfEvaluation
        }
      })), this.state.answerStatus !== ANSWER_STATUS.UNANSWERED && /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_Question["default"].overlayClose, " ").concat(this.state.feedbackHidden ? _Question["default"].atRightBorder : '', "  ").concat(_DeviceInfoHelper["default"].isInternetExplorer() ? '' : _Question["default"].notIE),
        style: {
          display: this.state.showOverlay
        },
        onClick: this.state.feedbackHidden ? function (e) {
          e.stopPropagation();

          _this11.setState({
            specificFeedbackHidden: true,
            feedbackHidden: false,
            questionScrollingDisabled: true
          });
        } : function (e) {
          e.stopPropagation();

          _this11.setState({
            feedbackHidden: true,
            questionScrollingDisabled: false
          });
        }
      }, this.state.feedbackHidden ? /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], {
        style: {
          width: '60%',
          height: '60%',
          fontSize: 'xxx-large'
        }
      }) : /*#__PURE__*/_react["default"].createElement(_Clear["default"], {
        style: {
          fontSize: 'x-large'
        }
      })), !this.state.textfieldFocusedBefore && this.state.selectedAnswers.length === 0 && (this.props.question.type === QUESTION_TYPES.VALNUM || this.props.question.type === QUESTION_TYPES.VALSTR || this.props.question.type === QUESTION_TYPES.SE) ? /*#__PURE__*/_react["default"].createElement("div", {
        id: "focusOverlay",
        className: _config["default"].allowDifferentQuestionBoxSizes ? _Question["default"].focusOverlayWithScrollableQuestions : _Question["default"].focusOverlay,
        style: {
          width: this.state.overlay.width,
          height: _config["default"].allowDifferentQuestionBoxSizes ? "calc(".concat(this.state.overlay.height, "px - 60vh)") : this.state.overlay.height
        },
        onClick: this.props.disableAnswers ? function () {
          _this11.props.onSubmitAnswer();
        } : function () {
          _this11.focusInput();
        }
      }) : null, this.state.imgOverlay ? /*#__PURE__*/_react["default"].createElement("div", {
        id: "imgOverlayContainer"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "imgOverlay",
        className: _Question["default"].imgOverlay,
        style: {
          width: this.state.overlay.width,
          height: this.state.overlay.height
        },
        onClick: function onClick() {
          _this11.showImageOverlay(document.getElementById('img'));
        }
      }), /*#__PURE__*/_react["default"].createElement("img", {
        id: "img",
        alt: "img",
        src: this.state.imgLink,
        className: _Question["default"].overlayImg,
        onClick: function onClick() {
          _this11.showImageOverlay(document.getElementById('img'));
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Question["default"].overlayImgClose,
        onClick: function onClick() {
          _this11.showImageOverlay(document.getElementById('img'));
        }
      }, /*#__PURE__*/_react["default"].createElement(_Clear["default"], {
        style: {
          fontSize: 'x-large'
        }
      }))) : null, this.state.textZoomed ? /*#__PURE__*/_react["default"].createElement("div", {
        id: "textOverlayContainer"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "textOverlay",
        className: _Question["default"].imgOverlay,
        style: {
          width: this.state.overlay.width,
          height: this.state.overlay.height
        },
        onClick: function onClick() {
          _this11.setState({
            textZoomed: false,
            textToZoom: null,
            zoomDivPosition: null,
            isZoomedQuestion: false,
            zoomTransform: null,
            zoomScale: 1,
            zoomFinished: false
          });
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: this.state.isZoomedQuestion ? _Question["default"].zoomedTextContainerQuestion : _Question["default"].zoomedTextContainerAnswer,
        style: {
          left: this.state.zoomDivPosition.left,
          top: this.state.zoomTransform && this.state.isZoomedQuestion ? '0' : this.state.zoomDivPosition.top,
          width: this.state.zoomDivPosition.right - this.state.zoomDivPosition.left,
          height: this.state.zoomFinished ? 'auto' : this.state.zoomDivPosition.bottom - this.state.zoomDivPosition.top,
          transform: this.state.zoomTransform,
          fontSize: this.state.zoomFinished ? "".concat(1 / this.state.zoomScale * 20, "px") : null,
          padding: this.state.zoomFinished ? '20px' : '6px',
          paddingTop: this.state.zoomFinished ? '35px' : '6px'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _Question["default"].zoomedTextInnerContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: this.state.isZoomedQuestion ? this.state.animationFinished ? {
          overflow: 'auto',
          textAlign: 'left'
        } : {
          overflow: 'hidden',
          textAlign: 'left'
        } : this.state.animationFinished ? {
          overflow: 'auto',
          textAlign: 'center'
        } : {
          overflow: 'hidden',
          textAlign: 'center'
        },
        className: _Question["default"].zoomedText,
        dangerouslySetInnerHTML: {
          __html: this.state.textToZoom
        }
      })), this.state.zoomFinished && /*#__PURE__*/_react["default"].createElement("div", {
        className: this.state.isZoomedQuestion ? _Question["default"].overlayTextCloseQuestion : _Question["default"].overlayTextCloseAnswer,
        style: {
          transform: "scale(".concat(1 / this.state.zoomScale, ")")
        },
        onClick: function onClick() {
          _this11.setState({
            textZoomed: false,
            textToZoom: null,
            zoomDivPosition: null,
            isZoomedQuestion: false,
            zoomTransform: null,
            zoomScale: 1,
            zoomFinished: false,
            animationFinished: false
          });
        }
      }, /*#__PURE__*/_react["default"].createElement(_Clear["default"], {
        style: {
          fontSize: 'x-large'
        }
      })))) : null, this.state.answerStatus !== ANSWER_STATUS.UNANSWERED && !this.state.feedbackHidden && hideFeedbackByGroup && /*#__PURE__*/_react["default"].createElement("div", {
        id: "overlayIcon",
        className: _Question["default"].feedbackOverlayIcon,
        style: overlayStyles.neutral,
        onClick: function onClick() {
          _this11.props.reviewMode ? _this11.props.goToStatistic() : _this11.onNextQuestion(true);
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _Question["default"].neutralText
      }, /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], {
        style: {
          fontSize: 'xx-large',
          marginBottom: '5px'
        }
      }), /*#__PURE__*/_react["default"].createElement("span", {
        style: overlayStyles.text
      }, this.props.reviewMode ? 'Zurück zur Statistik' : 'Weiter'))), this.state.answerStatus === ANSWER_STATUS.CORRECT && !this.state.feedbackHidden && !hideFeedbackByGroup && !_config["default"].showMinimalizedFeedbackIcon && /*#__PURE__*/_react["default"].createElement("div", {
        id: "overlayIcon",
        className: _Question["default"].feedbackOverlayIcon,
        style: overlayStyles.correct,
        onClick: function onClick() {
          _this11.props.reviewMode ? _this11.props.goToStatistic() : _this11.onNextQuestion(true);
        }
      }, /*#__PURE__*/_react["default"].createElement(_ThumbUp["default"], {
        className: _Question["default"].thumbIcon
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: (overlayStyles.text, {
          marginTop: '100%'
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: overlayStyles.smallLine
      }), "Richtig!"), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          paddingTop: this.props.isInKesi ? '0%' : '35%'
        }
      }, /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], {
        style: {
          fontSize: 'xx-large',
          marginBottom: '5px'
        }
      }), /*#__PURE__*/_react["default"].createElement("span", {
        style: overlayStyles.text
      }, this.props.reviewMode ? 'Zurück zur Statistik' : 'Weiter'))), this.state.answerStatus === ANSWER_STATUS.CORRECT && !this.state.feedbackHidden && !hideFeedbackByGroup && _config["default"].showMinimalizedFeedbackIcon && /*#__PURE__*/_react["default"].createElement("div", {
        id: "overlayIcon",
        className: _Question["default"].feedbackOverlayIcon,
        style: overlayStyles.correct,
        onClick: function onClick() {
          _this11.props.reviewMode ? _this11.props.goToStatistic() : _this11.onNextQuestion(true);
        }
      }, /*#__PURE__*/_react["default"].createElement(_ThumbUp["default"], {
        className: _Question["default"].thumbIcon
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: overlayStyles.correct.height
        }
      }, /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], {
        style: {
          fontSize: 'xx-large',
          marginBottom: '5px'
        }
      }), /*#__PURE__*/_react["default"].createElement("span", {
        style: (0, _assign["default"])({
          fontWeight: 'bold'
        }, overlayStyles.text)
      }, this.props.reviewMode ? ' Zurück zur Statistik' : '  Weiter'))), this.state.answerStatus === ANSWER_STATUS.WRONG && !this.state.feedbackHidden && !hideFeedbackByGroup && !_config["default"].showMinimalizedFeedbackIcon && /*#__PURE__*/_react["default"].createElement("div", {
        id: "overlayIcon",
        className: _Question["default"].feedbackOverlayIcon,
        style: overlayStyles.wrong,
        onClick: function onClick() {
          _this11.props.reviewMode ? _this11.props.goToStatistic() : _this11.onNextQuestion(true);
        }
      }, /*#__PURE__*/_react["default"].createElement(_ThumbDown["default"], {
        className: _Question["default"].thumbIcon
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: (overlayStyles.text, {
          marginTop: '100%'
        })
      }, "Leider", /*#__PURE__*/_react["default"].createElement("br", null), "falsch!"), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          paddingTop: this.props.isInKesi ? '0%' : '35%'
        }
      }, /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], {
        style: {
          fontSize: 'xx-large',
          marginBottom: '5px'
        }
      }), /*#__PURE__*/_react["default"].createElement("span", {
        style: overlayStyles.text
      }, this.props.reviewMode ? 'Zurück zur Statistik' : 'Weiter'))), this.state.answerStatus === ANSWER_STATUS.WRONG && !this.state.feedbackHidden && !hideFeedbackByGroup && _config["default"].showMinimalizedFeedbackIcon && /*#__PURE__*/_react["default"].createElement("div", {
        id: "overlayIcon",
        className: _Question["default"].feedbackOverlayIcon,
        style: overlayStyles.wrong,
        onClick: function onClick() {
          _this11.props.reviewMode ? _this11.props.goToStatistic() : _this11.onNextQuestion(true);
        }
      }, /*#__PURE__*/_react["default"].createElement(_ThumbDown["default"], {
        className: _Question["default"].thumbIcon
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: overlayStyles.correct.height
        }
      }, /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], {
        style: {
          fontSize: 'xx-large',
          marginBottom: '5px'
        }
      }), /*#__PURE__*/_react["default"].createElement("span", {
        style: (0, _assign["default"])({
          fontWeight: 'bold'
        }, overlayStyles.text)
      }, this.props.reviewMode ? ' Zurück zur Statistik' : '  Weiter'))), this.state.answerStatus === ANSWER_STATUS.TIME_OVER && !this.state.feedbackHidden && !hideFeedbackByGroup && !_config["default"].showMinimalizedFeedbackIcon && /*#__PURE__*/_react["default"].createElement("div", {
        id: "overlayIcon",
        className: _Question["default"].feedbackOverlayIcon,
        style: overlayStyles.wrong,
        onClick: function onClick() {
          _this11.props.reviewMode ? _this11.props.goToStatistic() : _this11.onNextQuestion(true);
        }
      }, /*#__PURE__*/_react["default"].createElement(_ThumbDown["default"], {
        className: _Question["default"].thumbIcon
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: (overlayStyles.text, {
          marginTop: '100%'
        })
      }, "Die Zeit", /*#__PURE__*/_react["default"].createElement("br", null), "ist um!"), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          paddingTop: this.props.isInKesi ? '0%' : '35%'
        }
      }, /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], {
        style: {
          fontSize: 'xx-large',
          marginBottom: '5px'
        }
      }), /*#__PURE__*/_react["default"].createElement("span", {
        style: overlayStyles.text
      }, this.props.reviewMode ? 'Zurück zur Statistik' : 'Weiter'))), this.state.answerStatus === ANSWER_STATUS.TIME_OVER && !this.state.feedbackHidden && !hideFeedbackByGroup && _config["default"].showMinimalizedFeedbackIcon && /*#__PURE__*/_react["default"].createElement("div", {
        id: "overlayIcon",
        className: _Question["default"].feedbackOverlayIcon,
        style: overlayStyles.wrong,
        onClick: function onClick() {
          _this11.props.reviewMode ? _this11.props.goToStatistic() : _this11.onNextQuestion(true);
        }
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_ThumbDown["default"], {
        className: _Question["default"].thumbIcon
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: overlayStyles.correct.height
        }
      }, /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], {
        style: {
          fontSize: 'xx-large',
          marginBottom: '5px'
        }
      }), /*#__PURE__*/_react["default"].createElement("span", {
        style: (0, _assign["default"])({
          fontWeight: 'bold'
        }, overlayStyles.text)
      }, this.props.reviewMode ? ' Zurück zur Statistik' : '  Weiter')))), (showFeedback || this.state.showMCAlert) &&
      /*#__PURE__*/
      //!doNotShowMainFeedback &&
      _react["default"].createElement("div", {
        className: _Question["default"].popupContainer,
        onClick: _config["default"].nextQuestionOnButtonOnly ? function () {
          console.log('feedback click intercepted');
        } : function () {
          _this11.props.reviewMode ? _this11.props.goToStatistic() : _this11.onNextQuestion(true);
        },
        style: paddingStyle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.refDivScroll,
        className: this.props.isInKesi ? _Question["default"].popupContentKesi : _Question["default"].popupContent,
        style: _config["default"].showFeedbackOverAnswers ? this.state.answerStatus === ANSWER_STATUS.CORRECT ? {
          top: '50%',
          border: style.correctStyle.border
        } : {
          top: '50%',
          border: style.wrongStyle.border
        } : this.state.answerStatus === ANSWER_STATUS.CORRECT ? {
          border: style.correctStyle.border
        } : {
          border: style.wrongStyle.border
        },
        onScroll: this.handleScrolling
      }, showFeedback ? this.getFeedback() : null, this.state.showMCAlert ? this.renderMCAlert() : null, showFeedback ? this.hasKesiAction() : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _Question["default"].overlayCloseSpecific,
        onClick: function onClick(e) {
          e.stopPropagation();

          _this11.setState({
            feedbackHidden: true,
            showMCAlert: false,
            questionScrollingDisabled: false
          });
        }
      }, /*#__PURE__*/_react["default"].createElement(_Clear["default"], {
        style: {
          fontSize: 'x-large'
        }
      })))), !this.state.specificFeedbackHidden && /*#__PURE__*/_react["default"].createElement("div", {
        className: this.props.isInKesi ? _Question["default"].popupContainerBrowser : _Question["default"].popupContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _Question["default"].popupContent,
        ref: this.refDivScroll,
        onScroll: this.handleScrolling
      }, this.renderSpecificFeedback(this.specificFeedback))), showSelfEvaluation && /*#__PURE__*/_react["default"].createElement("div", {
        className: _Question["default"].popupContainerSelfEvaluation,
        style: paddingStyle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.refDivScroll,
        className: _Question["default"].popupContent,
        style: {
          height: '100%'
        },
        onScroll: this.handleScrolling
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _Question["default"].popupContainerSelfEvaluationInstruction
      }, "".concat((0, _QuizStrings.getString)('RATE_YOUR_ANSWERS'), " ").concat(this.props.question.instructionText ? this.props.question.instructionText : '')), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Question["default"].popupContainerSelfEvaluationContent,
        dangerouslySetInnerHTML: {
          __html: this.props.question.feedback
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Question["default"].popupContainerSelfEvaluationStatic
      }, /*#__PURE__*/_react["default"].createElement(_Counter["default"], {
        limit: this.props.question.score,
        amount: 0.5,
        callback: function callback(score) {
          return _this11.selfEvaluationScore = score;
        }
      }), /*#__PURE__*/_react["default"].createElement(_index["default"], {
        width: '50%',
        className: _Question["default"].popupContainerSelfEvaluationButton,
        onClick: function onClick() {
          _this11.onSelectAnswer(_this11.state.selfEvaluationAnswer, _this11.selfEvaluationScore);
        }
      }, (0, _QuizStrings.getString)('SEND_SELF_EVALUATION'))))), _config["default"].showQDQuestionFeedbackButton ? this.renderUserFeedbackButton() : null));
    }
  }]);
  return Question;
}(_DataStoreComponent2["default"]); // noinspection Eslint


Question.propTypes = {
  question: _propTypes["default"].object.isRequired,
  // eslint-disable-line
  sequences: _propTypes["default"].object,
  selectedAnswers: _propTypes["default"].object,
  reviewMode: _propTypes["default"].bool,
  onSubmitAnswer: _propTypes["default"].func.isRequired,
  setTitle: _propTypes["default"].func,
  sidebarDocked: _propTypes["default"].bool,
  padding: _propTypes["default"].number,
  currentRound: _propTypes["default"].number,
  isSinglePlayer: _propTypes["default"].bool,
  isInKesi: _propTypes["default"].bool,
  parentDomId: _propTypes["default"].string,
  setRenderTimerBarFn: _propTypes["default"].func,
  onTimerBarStateUpdate: _propTypes["default"].func,
  disableAnswers: _propTypes["default"].bool,
  goToStatistic: _propTypes["default"].func,
  reducePointsOnError: _propTypes["default"].bool,
  numberOfQuestions: _propTypes["default"].number
};
Question.defaultProps = {
  isSinglePlayer: false,
  isInKesi: false,
  disableAnswers: false
};
var _default = Question;
exports["default"] = _default;